const mgmt = {
  // Navigation
  'nav.dashboard': 'ダッシュボード',
  'nav.projects': 'プロジェクト',
  'nav.instructions': '指示書',
  'nav.dailyLog': '日報',
  'nav.alerts': 'アラート',
  'nav.newProject': '新規プロジェクト',
  'nav.management': '管理',
  'nav.logout': 'ログアウト',
  'nav.menu': 'メニュー',
  'nav.actions': 'アクション',

  // Language switcher
  'lang.en': 'EN',
  'lang.ja': 'JP',
  'lang.zh': '中文',
  'lang.label': '言語',

  // Dashboard
  'dashboard.title': 'ダッシュボード',
  'dashboard.subtitle': 'プロジェクト管理パネル',
  'dashboard.projectControl': 'プロジェクト管理',
  'dashboard.activeProjects': '進行中',
  'dashboard.completed': '完了',
  'dashboard.onHold': '保留中',
  'dashboard.planning': '計画中',
  'dashboard.allProjects': '全プロジェクト',
  'dashboard.inProgressNow': '現在進行中',
  'dashboard.fullyFinished': '完全完了',
  'dashboard.blockedProjects': '保留プロジェクト',
  'dashboard.notYetStarted': '未開始',
  'dashboard.viewAll': 'すべて表示',
  'dashboard.manage': '管理',
  'dashboard.noProjects': 'プロジェクトなし',
  'dashboard.createFirst': '最初のプロジェクトを作成して始めましょう',
  'dashboard.createFirstProject': '最初のプロジェクトを作成',
  'dashboard.noActiveProjects': '進行中のプロジェクトなし',
  'dashboard.createProject': 'プロジェクトを作成',
  'dashboard.moreProjects': '+{count} 件のプロジェクト',

  // Project statuses
  'status.active': '進行中',
  'status.planning': '計画中',
  'status.onHold': '保留中',
  'status.complete': '完了',
  'status.completed': '完了',
  'status.closed': 'クローズ',
  'status.draft': '下書き',
  'status.sent': '送信済み',
  'status.pending': '保留',
  'status.approved': '承認済み',
  'status.rejected': '却下',
  'status.inProgress': '進行中',
  'status.notStarted': '未開始',
  'status.delayed': '遅延',

  // Projects page
  'projects.title': 'プロジェクト',
  'projects.search': 'プロジェクト、クライアント、住所を検索...',
  'projects.noAddress': '住所未設定',
  'projects.noClient': 'クライアント未設定',
  'projects.noAddressShort': '住所なし',
  'projects.noProjectsFound': 'プロジェクトが見つかりません',
  'projects.tryAdjusting': '検索条件やフィルターを変更してください',
  'projects.noMatchFilter': 'このフィルターに一致するプロジェクトはありません',
  'projects.clearSearch': '検索をクリア',
  'projects.loadingProjects': 'プロジェクトを読み込み中...',
  'projects.project': 'プロジェクト',
  'projects.projects': 'プロジェクト',
  'projects.matching': '一致',
  'projects.schedFinal': 'スケジュール',
  'projects.clFinal': 'チェックリスト',

  // Project detail tabs
  'tabs.overview': '概要',
  'tabs.stages': 'ステージ',
  'tabs.schedule': 'スケジュール',
  'tabs.checklist': 'チェックリスト',
  'tabs.photos': '写真',
  'tabs.files': 'ファイル',
  'tabs.tasks': 'タスク',
  'tabs.notifications': '通知',
  'tabs.questions': '質問',
  'tabs.dailyLog': '日報',
  'tabs.instructions': '指示',
  'tabs.payments': '支払い',
  'tabs.more': 'その他',

  // Project detail overview
  'overview.projectDetails': 'プロジェクト詳細',
  'overview.client': 'クライアント',
  'overview.type': '種類',
  'overview.startDate': '開始日',
  'overview.estCompletion': '完了予定日',
  'overview.status': 'ステータス',
  'overview.currentStage': '現在のステージ',
  'overview.projectProgress': 'プロジェクト進捗',
  'overview.scheduleFinal': 'スケジュール最終',
  'overview.checklistFinal': 'チェックリスト最終',
  'overview.pendingScheduleItems': '保留中のスケジュール項目',
  'overview.description': '説明',
  'overview.files': 'ファイル',
  'overview.schedule': 'スケジュール',
  'overview.recalculateProgress': 'プロジェクト進捗を再計算',
  'overview.editProject': 'プロジェクトを編集',
  'overview.projectSettings': 'プロジェクト設定',

  // Progress / stats
  'progress.projectProgress': 'プロジェクト進捗',
  'progress.management': '管理',
  'progress.subcontractor': '下請業者',
  'progress.stage': 'ステージ',
  'progress.loading': '読み込み中...',
  'progress.done': '完了',
  'progress.pending': '保留',
  'progress.waitingForSub': '下請業者の確認待ち',
  'progress.scheduleHealth': 'スケジュール健全性',
  'progress.reviewPendingSchedule': '保留中のスケジュールを確認',
  'progress.pendingScheduleItems': '{count} 件のスケジュール項目が保留中',
  'progress.checklistItemsPending': '{count} 件のチェックリスト項目が保留中',
  'progress.scheduleFormula': 'スケジュール最終 {sched}% × 50% + チェックリスト最終 {cl}% × 50% = {total}% プロジェクト進捗',
  'progress.mgmtChecksComplete': '管理チェック完了。下請業者の確認待ちです。',
  'progress.subPendingDesc': '{remaining} / {total} 件の下請業者必須チェックリスト項目が保留中です。',
  'progress.viewPendingItems': '保留中の項目を表示',

  // Notifications
  'notifications.title': '通知',
  'notifications.allNotifications': 'すべての通知',
  'notifications.projectNotifications': 'プロジェクト通知',
  'notifications.markAllRead': 'すべて既読にする',
  'notifications.noNotifications': '通知なし',
  'notifications.allCaughtUp': 'すべて確認済みです',
  'notifications.loading': '通知を読み込み中...',
  'notifications.justNow': 'たった今',
  'notifications.minAgo': '{n} 分前',
  'notifications.hrAgo': '{n} 時間前',
  'notifications.hrsAgo': '{n} 時間前',
  'notifications.dayAgo': '{n} 日前',
  'notifications.daysAgo': '{n} 日前',

  // Questions
  'questions.clientQuestions': 'クライアントの質問',
  'questions.unanswered': '未回答',
  'questions.noQuestions': '質問なし',
  'questions.clientQuestionsAppear': 'クライアントの質問がここに表示されます',
  'questions.managementReply': '管理者の返信',
  'questions.typeReply': '返信を入力...',
  'questions.sendReply': '返信を送信',

  // Instructions
  'instructions.title': '指示書',
  'instructions.subtitle': '下請業者への指示書を管理・追跡します',
  'instructions.newInstruction': '新規指示書',
  'instructions.changeOrder': '変更指示',
  'instructions.reload': '再読み込み',
  'instructions.total': '合計',
  'instructions.open': '未完了',
  'instructions.changeOrders': '変更指示',
  'instructions.completed': '完了',
  'instructions.closed': 'クローズ',
  'instructions.allProjects': '全プロジェクト',
  'instructions.allPriorities': '全優先度',
  'instructions.allStatuses': 'すべて',
  'instructions.sent': '送信済み',
  'instructions.inProgress': '進行中',
  'instructions.noInstructions': '指示書が見つかりません',
  'instructions.createInstruction': '下請業者に送る指示書を作成してください',
  'instructions.createChangeOrder': '変更指示を作成',
  'instructions.createFirstInstruction': '最初の指示書を作成',
  'instructions.to': '宛先',
  'instructions.due': '期限',
  'instructions.highPriority': '高優先度',
  'instructions.responseRequired': '返答必須',
  'instructions.readMore': '続きを読む',
  'instructions.showLess': '折りたたむ',
  'instructions.managementNote': '管理者メモ',
  'instructions.markCompleted': '完了にする',
  'instructions.markClosed': 'クローズにする',
  'instructions.viewInProject': 'プロジェクトで表示',
  'instructions.unassigned': '未割り当て',
  'instructions.items': '件',
  'instructions.instruction': '指示書',
  'instructions.internalDraft': '内部 / 下書き',
  'instructions.subcontractor': '下請業者',
  'instructions.clientLabel': 'クライアント',
  'instructions.reasonForChange': '変更理由',
  'instructions.currentFinish': '現在の完了予定',
  'instructions.newFinish': '新しい完了予定',
  'instructions.costImpact': 'コストへの影響',
  'instructions.scheduleImpact': 'スケジュールへの影響',
  'instructions.requiresClientApproval': 'クライアント承認が必要',
  'instructions.clientApproved': 'クライアント承認済み',
  'instructions.clientRejected': 'クライアント却下',

  // Daily Log
  'dailyLog.title': '日報レビュー',
  'dailyLog.createDailyLog': '日報を作成',
  'dailyLog.internalOnly': '内部のみ',
  'dailyLog.shareWithClient': 'クライアントと共有',
  'dailyLog.publishedToClient': 'クライアントに公開済み',
  'dailyLog.selectPhotos': '写真を選択',
  'dailyLog.managementComment': '管理者コメント',
  'dailyLog.internalNote': '内部メモ',
  'dailyLog.pendingReview': 'レビュー待ち',
  'dailyLog.approvedForClient': 'クライアント承認済み',
  'dailyLog.internalOnlyBadge': '内部のみ',
  'dailyLog.rejected': '却下',
  'dailyLog.allStatuses': '全ステータス',
  'dailyLog.allProjects': '全プロジェクト',
  'dailyLog.allStages': '全ステージ',
  'dailyLog.allSubcontractors': '全下請業者',
  'dailyLog.filters': 'フィルター',
  'dailyLog.showAll': 'すべて表示',
  'dailyLog.hide': '非表示',
  'dailyLog.pending': '保留中',
  'dailyLog.approve': '承認',
  'dailyLog.internal': '内部',
  'dailyLog.reject': '却下',
  'dailyLog.instruction': '指示書',
  'dailyLog.noPhotosMatch': 'フィルターに一致する写真がありません',
  'dailyLog.tryAdjusting': 'フィルターを変更してください',
  'dailyLog.noPhotosYet': '日報写真がまだアップロードされていません',
  'dailyLog.selected': '件選択中',
  'dailyLog.approveForClient': 'クライアント承認',
  'dailyLog.keepInternal': '内部のみ',
  'dailyLog.clearSelection': '選択をクリア',
  'dailyLog.apply': '適用',
  'dailyLog.applying': '適用中...',
  'dailyLog.cancel': 'キャンセル',
  'dailyLog.optionalNote': 'メモ（任意）...',
  'dailyLog.removePhoto': 'この写真を削除しますか？',
  'dailyLog.removePhotoDesc': '写真は削除済みとしてマークされます。この操作は元に戻せません。',
  'dailyLog.remove': '削除',
  'dailyLog.managementNoteLabel': '管理者メモ',
  'dailyLog.addNote': 'この写真についてメモを追加...',
  'dailyLog.saveNote': 'メモを保存',
  'dailyLog.clientVisible': 'クライアント表示',
  'dailyLog.selectAll': 'すべて選択',
  'dailyLog.deselectAll': '選択解除',
  'dailyLog.titleRequired': 'タイトル *',
  'dailyLog.titlePlaceholder': '例：基礎工事の進捗 — 5月11日',
  'dailyLog.visibility': '公開設定',
  'dailyLog.photosSelected': '{count} 枚の写真がこの日報に含まれます。',
  'dailyLog.creating': '作成中...',
  'dailyLog.retry': '再試行',
  'dailyLog.reset': 'リセット',

  // Photos tab
  'photos.title': 'フォトギャラリー',
  'photos.upload': 'アップロード',
  'photos.noPhotos': '写真なし',
  'photos.uploadToDocument': 'プロジェクトを記録するために写真をアップロードしてください',
  'photos.loadingPhotos': '写真を読み込み中...',
  'photos.deletePhoto': 'この写真を削除しますか？',
  'photos.cannotBeUndone': 'この操作は元に戻せません。',
  'photos.deleting': '削除中...',
  'photos.delete': '削除',
  'photos.cancel': 'キャンセル',
  'photos.uploadPhotos': '写真をアップロード',
  'photos.openPreview': 'プレビューを開く',

  // Files tab
  'files.title': 'プロジェクトファイル',
  'files.upload': 'アップロード',
  'files.folder': 'フォルダ',
  'files.recentFiles': '最近のファイル',
  'files.allFiles': '全ファイル',
  'files.total': '合計',
  'files.all': 'すべて',
  'files.visible': '表示',
  'files.hidden': '非表示',
  'files.noFiles': 'ファイルなし',
  'files.uploadToGetStarted': 'ファイルをアップロードして始めましょう',
  'files.uploadToFolder': 'このフォルダにファイルをアップロード',
  'files.newFolder': '新規フォルダ',
  'files.folderName': 'フォルダ名',
  'files.folderNamePlaceholder': '例：図面、請求書、契約書...',
  'files.createFolder': 'フォルダを作成',
  'files.loadingFiles': 'ファイルを読み込み中...',
  'files.openFile': 'ファイルを開く',
  'files.deleteFile': 'ファイルを削除',
  'files.hideFile': '非表示',
  'files.showFile': '表示',
  'files.uploadFiles': 'ファイルをアップロード',

  // Schedule tab
  'schedule.title': 'スケジュール',
  'schedule.scheduleFinal': 'スケジュール最終',
  'schedule.checklistFinal': 'チェックリスト最終',
  'schedule.projectProgress': 'プロジェクト進捗',
  'schedule.pendingItems': '保留中の項目',
  'schedule.complete': '完了',
  'schedule.completed': '完了済み',
  'schedule.notMapped': '未マッピング',
  'schedule.noChecklistMapped': 'チェックリスト未マッピング',
  'schedule.manualComplete': '手動完了',
  'schedule.criticalItems': 'クリティカル項目',
  'schedule.delayedItems': '遅延項目',
  'schedule.atRiskItems': 'リスク項目',
  'schedule.scheduleHealth': 'スケジュール健全性',
  'schedule.reviewPendingSchedule': '保留中のスケジュールを確認',
  'schedule.markAllPendingComplete': '保留中の全項目を完了にする',
  'schedule.recalculateProgress': 'プロジェクト進捗を再計算',
  'schedule.noScheduleYet': 'スケジュールがまだ作成されていません',
  'schedule.createFromTemplate': '開発テンプレートからスケジュールを作成',
  'schedule.scheduleItemsNeedDates': 'スケジュール項目に日付が必要です',
  'schedule.generateInitialTimeline': '初期タイムラインを生成',
  'schedule.noItemsMatchFilter': '現在のフィルターに一致するスケジュール項目がありません。',
  'schedule.clearFilters': 'フィルターをクリア',
  'schedule.retry': '再試行',
  'schedule.refreshing': 'スケジュールデータを更新中...',
  'schedule.markAllConfirmTitle': '保留中の全項目を完了にしますか？',
  'schedule.markAllConfirmDesc': '{count} 件のスケジュール項目を最終進捗100%で完了にします。',
  'schedule.markAllWarning': 'この操作は簡単には元に戻せません。',
  'schedule.marking': 'マーク中...',
  'schedule.markComplete': '{count} 件を完了にする',
  'schedule.cancel': 'キャンセル',
  'schedule.recalcCriticalPath': 'クリティカルパスを再計算しますか？',
  'schedule.recalcDesc': '現在のスケジュール項目とリンクからクリティカルパスを計算します。',
  'schedule.recalcWarning': '再計算後にクリティカルパスアラートが有効になります。',
  'schedule.calculating': '計算中...',
  'schedule.recalcAndSave': '再計算して保存',
  'schedule.setupInProgress': 'スケジュールをインポートしました。セットアップ中です。',
  'schedule.setupDesc': 'クリティカルパスアラートを使用する前に、チェックリストのマッピングと進捗追跡を完了してください。',
  'schedule.pendingCount': '{count} 件保留中',
  'schedule.scheduleComplete': 'スケジュール完了',
  'schedule.showDetails': '詳細を表示',
  'schedule.hideDetails': '詳細を非表示',
  'schedule.reviewPendingItems': '保留中の項目を確認',
  'schedule.noChecklistMapping': 'チェックリスト未マッピング',
  'schedule.incompleteChecklist': '未完了チェックリスト',
  'schedule.calculatedFrom': 'チェックリスト50% + スケジュール50%から計算',

  // Checklist tab
  'checklist.title': 'チェックリスト',
  'checklist.managementCheck': '管理チェック',
  'checklist.subcontractorCheck': '下請業者チェック',
  'checklist.finalApproval': '最終承認',
  'checklist.required': '必須',
  'checklist.checked': 'チェック済み',
  'checklist.unchecked': '未チェック',
  'checklist.fullyApproved': '完全承認',
  'checklist.waitManagement': '管理待ち',
  'checklist.waitSubcontractor': '下請業者待ち',
  'checklist.unmapped': '未マッピング',
  'checklist.allStages': '全ステージ',
  'checklist.allScheduleItems': '全スケジュール項目',
  'checklist.byStage': 'ステージ別',
  'checklist.bySection': 'セクション別',
  'checklist.noChecklistItems': 'チェックリスト項目なし',
  'checklist.createChecklist': 'チェックリストを作成',
  'checklist.createChecklistDesc': 'プロジェクトのマイルストーン、検査、承認を追跡するチェックリストを作成してください。',
  'checklist.loadingChecklist': 'チェックリストを読み込み中...',
  'checklist.failedToLoad': 'チェックリストの読み込みに失敗しました',
  'checklist.retry': '再試行',
  'checklist.unmappedItems': '未マッピングのチェックリスト項目',
  'checklist.unmappedDesc': 'これらの項目はスケジュール項目にリンクされていません。マッピングして整理してください。',
  'checklist.map': 'マップ',
  'checklist.cancel': 'キャンセル',
  'checklist.selectSchedule': 'スケジュールを選択...',
  'checklist.allChecked': 'すべてのチェックリスト項目がチェックされました。お疲れ様です！',
  'checklist.viewChecked': 'チェック済み項目を表示',
  'checklist.noItemsMatch': '現在のフィルターに一致するチェックリスト項目がありません。',
  'checklist.showAll': 'すべての項目を表示',
  'checklist.mgmtDone': '管理完了',
  'checklist.completeMgmt': '管理チェックを完了',
  'checklist.subDone': '下請業者完了',
  'checklist.completeSub': '下請業者チェックを完了',
  'checklist.finalComplete': '最終：完了',
  'checklist.waitingForSub': '下請業者待ち',
  'checklist.waitingForMgmt': '管理待ち',
  'checklist.requestAction': 'アクションを依頼',
  'checklist.refreshing': 'チェックリストデータを更新中...',
  'checklist.noMappedItems': '{stage} にマッピングされたチェックリスト項目がありません',
  'checklist.noMappedDesc': 'このステージにはまだリンクされたチェックリスト項目がありません。',
  'checklist.unmappedCount': '{count} 件の未マッピング項目',
  'checklist.progress': '{stage} の進捗',
  'checklist.managementDone': '管理：完了',
  'checklist.managementPending': '管理：保留',
  'checklist.subcontractorDone': '下請業者：完了',
  'checklist.subcontractorPending': '下請業者：保留',

  // Stages tab
  'stages.title': 'ステージ',
  'stages.noScheduleItems': 'スケジュール項目なし',
  'stages.createScheduleFirst': 'スケジュールタブからスケジュールを作成して、チェックリスト項目とリンクされたステージを確認してください。',
  'stages.failedToLoad': 'ステージの読み込みに失敗しました',
  'stages.retry': '再試行',
  'stages.suggestedStage': '推奨現在ステージ',
  'stages.updateProjectStage': 'プロジェクトステージを更新',
  'stages.updateStageTitle': 'プロジェクトステージを更新',
  'stages.updateStageConfirm': 'このプロジェクトを {stage} に移動してもよいですか？',
  'stages.updateStageDesc': 'スケジュールの完了状況に基づいてプロジェクトの現在のステージが更新されます。',
  'stages.cancel': 'キャンセル',
  'stages.current': '現在',
  'stages.scheduleComplete': 'スケジュール完了',
  'stages.schedule': 'スケジュール',
  'stages.checklistFinal': 'チェックリスト最終',
  'stages.noChecklistMapped': 'チェックリスト未マッピング — スケジュールのみ',
  'stages.combinedProgress': 'ステージ進捗（合計）',
  'stages.checklistFinalApproval': 'チェックリスト最終承認',
  'stages.paymentMilestones': '支払いマイルストーン',
  'stages.backToAll': '全建設項目に戻る',
  'stages.oneOrMoreDelayed': '1件以上の項目が遅延しています',
  'stages.notMapped': 'チェックリスト未マッピング — 完了としてカウント',
  'stages.checklistComplete': 'チェックリスト完了',
  'stages.checklistIncomplete': 'チェックリスト未完了',
  'stages.manuallyCompleted': '手動完了',
  'stages.manual': '手動 {pct}% — チェックリストなし',

  // Tasks tab
  'tasks.title': 'タスク',
  'tasks.open': '未完了',
  'tasks.overdue': '期限超過',
  'tasks.total': '合計',
  'tasks.all': 'すべて',
  'tasks.decision': '決定',
  'tasks.payment': '支払い',
  'tasks.completed': '完了',
  'tasks.newTask': '新規',
  'tasks.noTasks': 'タスクなし',
  'tasks.createTask': 'タスクを作成して始めましょう',
  'tasks.noTasksAssigned': 'タスクが割り当てられていません',
  'tasks.loadingTasks': 'タスクを読み込み中...',
  'tasks.taskType': 'タスク種類',
  'tasks.assignTo': '担当者',
  'tasks.dueDate': '期限',
  'tasks.description': '説明',
  'tasks.options': 'オプション',
  'tasks.invoiceNo': '請求書番号',
  'tasks.amount': '金額（$）',
  'tasks.paymentDueDate': '支払期限',
  'tasks.creating': '作成中...',
  'tasks.createTask2': 'タスクを作成',
  'tasks.title2': 'タイトル *',
  'tasks.titlePlaceholder': '例：タイル選択が必要',
  'tasks.descPlaceholder': '必要な作業を説明してください...',
  'tasks.addOption': '+ オプションを追加',
  'tasks.optionLabel': 'オプションラベル',
  'tasks.optionDesc': '説明（任意）',
  'tasks.priceNote': '価格メモ（任意）',
  'tasks.invoicePlaceholder': '例：PC-003',
  'tasks.amountPlaceholder': '例：35000',
  'tasks.selectThisOption': 'このオプションを選択',
  'tasks.selectionConfirmed': '選択確認済み',
  'tasks.respond': '返答',
  'tasks.typeResponse': '返答を入力...',
  'tasks.submitResponse': '返答を送信',
  'tasks.markAsPaid': '支払い済みにする',
  'tasks.paymentRef': '支払い参照番号 / 取引ID',
  'tasks.paymentNote': 'メモ（任意）',
  'tasks.confirmPayment': '支払い受領を確認',
  'tasks.close': '閉じる',
  'tasks.due': '期限',
  'tasks.options2': 'オプション',
  'tasks.selected': '選択済み',
  'tasks.invoiceDetails': '請求書詳細',
  'tasks.paymentStatus': '支払いステータス',
  'tasks.reference': '参照',
  'tasks.response': '返答',

  // New Project wizard
  'newProject.title': '新規プロジェクト',
  'newProject.projectInfo': 'プロジェクト情報',
  'newProject.basicDetails': 'プロジェクトの基本情報',
  'newProject.projectName': 'プロジェクト名',
  'newProject.projectNamePlaceholder': '例：ヘンダーソンリノベーション',
  'newProject.siteAddress': '現場住所',
  'newProject.siteAddressPlaceholder': '例：42 Bethells Rd, Henderson, Auckland',
  'newProject.clientName': 'クライアント名',
  'newProject.clientNamePlaceholder': '例：山本ファミリー',
  'newProject.projectDescription': 'プロジェクト説明',
  'newProject.descPlaceholder': 'プロジェクトの範囲の簡単な説明...',
  'newProject.projectType': 'プロジェクト種類',
  'newProject.selectType': '建設プロジェクトの種類を選択してください',
  'newProject.scheduleSetup': 'スケジュール設定',
  'newProject.coverPhoto': 'カバー写真',
  'newProject.teamAccess': 'チームアクセス',
  'newProject.stages': '建設ステージ',
  'newProject.overallSchedule': '全体スケジュール',
  'newProject.paymentSchedule': '支払いスケジュール',
  'newProject.reviewCreate': '確認して作成',
  'newProject.continue': '続ける',
  'newProject.back': '戻る',
  'newProject.createProject': 'プロジェクトを作成',
  'newProject.creatingProject': 'プロジェクトを作成中...',
  'newProject.viewProject': 'プロジェクトを表示',
  'newProject.projectCreated': 'プロジェクトが正常に作成されました！',
  'newProject.startDate': 'プロジェクト開始日',
  'newProject.estCompletion': '完了予定日',
  'newProject.subcontractor': '下請業者',
  'newProject.client': 'クライアント',
  'newProject.optional': '（任意）',
  'newProject.emailAddress': 'メールアドレス',
  'newProject.contactName': '担当者名',
  'newProject.company': '会社名',
  'newProject.fullName': '氏名',
  'newProject.selectStages': 'このプロジェクトに適用するステージを選択してください',
  'newProject.stagesSelected': '{count} ステージ選択済み',
  'newProject.reviewDetails': '作成前にすべての詳細を確認してください',
  'newProject.projectDetails': 'プロジェクト詳細',
  'newProject.scheduleSetupLabel': 'スケジュール設定',
  'newProject.stagesLabel': 'ステージ',
  'newProject.teamLabel': 'チーム',
  'newProject.paymentScheduleLabel': '支払いスケジュール',
  'newProject.noPaymentSchedule': '支払いスケジュールなし — 後でプロジェクト編集から追加できます',
  'newProject.readyToCreate': 'このプロジェクトを作成しますか？',
  'newProject.uniqueCode': '一意のプロジェクトコードが自動的に生成されます。',

  // Edit Project
  'editProject.title': 'プロジェクトを編集',
  'editProject.basicInfo': '基本情報',
  'editProject.typeCover': '種類とカバー',
  'editProject.stages': 'ステージ',
  'editProject.schedule': 'スケジュール',
  'editProject.payments': '支払い',
  'editProject.saveChanges': '変更を保存',
  'editProject.savingChanges': '変更を保存中...',
  'editProject.changesSaved': '変更が正常に保存されました',
  'editProject.projectName': 'プロジェクト名',
  'editProject.siteAddress': '現場住所',
  'editProject.clientName': 'クライアント名',
  'editProject.projectDescription': 'プロジェクト説明',
  'editProject.projectType': 'プロジェクト種類',
  'editProject.coverPhoto': 'カバー写真',
  'editProject.constructionStages': '建設ステージ',
  'editProject.addNewStage': '新しいステージを追加',
  'editProject.stageName': 'ステージ名...',
  'editProject.add': '追加',
  'editProject.completion': '完了率',
  'editProject.planned': '計画',
  'editProject.actual': '実績',
  'editProject.start': '開始',
  'editProject.end': '終了',
  'editProject.delayReason': '遅延理由',
  'editProject.delayReasonPlaceholder': '遅延の理由を説明してください...',
  'editProject.overallSchedule': '全体スケジュール',
  'editProject.startDate': 'プロジェクト開始日',
  'editProject.estCompletion': '完了予定日',
  'editProject.resetToDefault': 'デフォルトカバーにリセット',
  'editProject.coverUrlPlaceholder': 'https://...（デフォルトを使用する場合は空白）',

  // Common buttons
  'btn.save': '保存',
  'btn.cancel': 'キャンセル',
  'btn.delete': '削除',
  'btn.edit': '編集',
  'btn.upload': 'アップロード',
  'btn.download': 'ダウンロード',
  'btn.submit': '送信',
  'btn.send': '送信',
  'btn.continue': '続ける',
  'btn.back': '戻る',
  'btn.close': '閉じる',
  'btn.reload': '再読み込み',
  'btn.review': '確認',
  'btn.filter': 'フィルター',
  'btn.search': '検索',
  'btn.reset': 'リセット',
  'btn.confirm': '確認',
  'btn.markComplete': '完了にする',
  'btn.markResolved': '解決済みにする',
  'btn.markClosed': 'クローズにする',
  'btn.newProject': '新規プロジェクト',
  'btn.newInstruction': '新規指示書',
  'btn.changeOrder': '変更指示',
  'btn.sendInstruction': '指示書を送信',
  'btn.saveDraft': '下書きを保存',
  'btn.assignSubcontractor': '下請業者を割り当て',
  'btn.tryAgain': '再試行',
  'btn.retry': '再試行',
  'btn.new': '新規',
  'btn.apply': '適用',
  'btn.dismiss': '閉じる',
  'btn.updateStage': 'プロジェクトステージを更新',

  // Forms
  'form.projectName': 'プロジェクト名',
  'form.address': '住所',
  'form.client': 'クライアント',
  'form.type': '種類',
  'form.startDate': '開始日',
  'form.estCompletion': '完了予定日',
  'form.status': 'ステータス',
  'form.priority': '優先度',
  'form.dueDate': '期限',
  'form.title': 'タイトル',
  'form.message': 'メッセージ',
  'form.description': '説明',
  'form.attachment': '添付ファイル',
  'form.uploadFile': 'ファイルをアップロード',
  'form.uploadPhoto': '写真をアップロード',
  'form.selectProject': 'プロジェクトを選択',
  'form.selectSubcontractor': '下請業者を選択',
  'form.selectClient': 'クライアントを選択',
  'form.required': '*',

  // Errors / empty states
  'error.noDataFound': 'データが見つかりません',
  'error.noProjectsFound': 'プロジェクトが見つかりません',
  'error.noInstructionsYet': '指示書がまだありません',
  'error.noSubcontractorsAssigned': '下請業者が割り当てられていません',
  'error.couldNotLoadData': 'データを読み込めませんでした',
  'error.uploadFailed': 'アップロードに失敗しました',
  'error.saveFailed': '保存に失敗しました',
  'error.pleaseTryAgain': '再試行してください',
  'error.areYouSure': 'よろしいですか？',
  'error.cannotBeUndone': 'この操作は元に戻せません',
  'error.projectNotFound': 'プロジェクトが見つかりません',
  'error.backToProjects': 'プロジェクト一覧に戻る',
  'error.failedToLoad': '読み込みに失敗しました',

  // Logout
  'logout.signOut': 'サインアウトしますか？',
  'logout.signOutDesc': 'JPH Portalからサインアウトします。',
  'logout.cancel': 'キャンセル',
  'logout.signOutBtn': 'サインアウト',

  // User menu
  'user.management': '管理',
  'user.jphPortal': 'JPH Portal',
  'user.producedBy': 'Japan Homes Group 制作',

  // Change password
  'password.changeTitle': 'パスワード変更',
  'password.current': '現在のパスワード',
  'password.new': '新しいパスワード',
  'password.confirmNew': '新しいパスワード（確認）',
  'password.cancel': 'キャンセル',
  'password.save': 'パスワードを更新',
  'password.changeSuccess': 'パスワードを更新しました',
  'password.changeSuccessHint': 'パスワードが変更されました。引き続きご利用いただけます。別の端末で再ログインを求められた場合は、新しいパスワードでサインインしてください。',
  'password.signInAgain': '再ログイン',
  'password.continue': '続ける',
  'nav.changePassword': 'パスワード変更',

  // Status labels (for DB values → display)
  'statusLabel.active': '進行中',
  'statusLabel.planning': '計画中',
  'statusLabel.on_hold': '保留中',
  'statusLabel.complete': '完了',
  'statusLabel.completed': '完了',
  'statusLabel.closed': 'クローズ',
  'statusLabel.draft': '下書き',
  'statusLabel.sent': '送信済み',
  'statusLabel.seen': '既読',
  'statusLabel.in_progress': '進行中',
  'statusLabel.replied': '返信済み',
  'statusLabel.pending': '保留',
  'statusLabel.approved': '承認済み',
  'statusLabel.rejected': '却下',
  'statusLabel.unknown': '不明',
  'statusLabel.unassigned': '未割り当て',
  'statusLabel.unknown_project': '不明なプロジェクト',

  // Checklist inline labels
  'checklist.managementDoneShort': '管理完了',
  'checklist.completeMgmtShort': '管理チェックを完了',
  'checklist.subDoneShort': '下請業者完了',
  'checklist.completeSubShort': '下請業者チェックを完了',
  'checklist.finalCompleteShort': '最終：完了',
  'checklist.waitingForSubShort': '下請業者待ち',
  'checklist.waitingForMgmtShort': '管理待ち',
  'checklist.requestActionShort': 'アクションを依頼',
  'checklist.checksLabel': '件のチェック',
  'checklist.finalApprovalLabel': '最終承認',
  'checklist.completedLabel': '完了',
  'checklist.requiredLabel': '必須',
  'checklist.unmappedLabel': '未マッピング',
  'checklist.noChecklistMappedScheduleOnly': 'チェックリスト未マッピング — スケジュールのみ',
  'checklist.allItemsChecked': 'すべてのチェックリスト項目がチェックされました。お疲れ様です！',
  'checklist.noItemsMatchFilters': '現在のフィルターに一致するチェックリスト項目がありません。',
  'checklist.noItemsMatchFilter': '現在のフィルターに一致するチェックリスト項目がありません。',
  'checklist.showAllItems': 'すべての項目を表示',
  'checklist.viewCheckedItems': 'チェック済み項目を表示',
  'checklist.unmappedItemsCount': '{count} 件の未マッピング',
  'checklist.noScheduleItemsInStage': 'このステージにスケジュール項目がありません',
  'checklist.finalApprovalComplete': '最終承認は、すべての必須承認（管理 + 下請業者）が完了した場合のみ完了となります。',
  'checklist.waitingForSubChecks': '下請業者の確認待ち',
  'checklist.refreshingData': 'チェックリストデータを更新中...',
  'checklist.loadingText': 'チェックリストを読み込み中...',
  'checklist.failedToLoadText': 'チェックリストの読み込みに失敗しました',
  'checklist.createChecklistBtn': 'チェックリストを作成',
  'checklist.allConstructionSubStages': '全建設サブステージ',
  'checklist.allStagesOption': '全ステージ',
  'checklist.allScheduleItemsOption': '全スケジュール項目',
  'checklist.byStageOption': 'ステージ別',
  'checklist.bySectionOption': 'セクション別',
  'checklist.selectScheduleOption': 'スケジュールを選択...',
  'checklist.mapBtn': 'マップ',
  'checklist.cancelBtn': 'キャンセル',
  'checklist.unmappedItemsTitle': '未マッピングのチェックリスト項目',
  'checklist.unmappedItemsDesc': 'これらの項目はスケジュール項目にリンクされていません。マッピングして整理してください。',

  // Tasks inline labels
  'tasks.openLabel': '未完了',
  'tasks.overdueLabel': '期限超過',
  'tasks.totalLabel': '合計',
  'tasks.noTasksLabel': 'タスクなし',
  'tasks.createTaskLabel': 'タスクを作成して始めましょう',
  'tasks.noTasksAssignedLabel': 'タスクが割り当てられていません',
  'tasks.loadingTasksLabel': 'タスクを読み込み中...',
  'tasks.newTaskBtn': '新規',
  'tasks.createTaskBtn': 'タスクを作成',
  'tasks.creatingLabel': '作成中...',
  'tasks.closeBtn': '閉じる',
  'tasks.dueLabel': '期限',
  'tasks.optionsCountLabel': 'オプション',
  'tasks.selectedLabel': '選択済み',
  'tasks.invoiceDetailsLabel': '請求書詳細',
  'tasks.paymentStatusLabel': '支払いステータス',
  'tasks.referenceLabel': '参照',
  'tasks.responseLabel': '返答',
  'tasks.respondLabel': '返答',
  'tasks.typeResponseLabel': '返答を入力...',
  'tasks.submitResponseBtn': '返答を送信',
  'tasks.markAsPaidBtn': '支払い済みにする',
  'tasks.paymentRefLabel': '支払い参照番号 / 取引ID',
  'tasks.paymentNoteLabel': 'メモ（任意）',
  'tasks.confirmPaymentBtn': '支払い受領を確認',
  'tasks.selectThisOptionBtn': 'このオプションを選択',
  'tasks.selectionConfirmedLabel': '選択確認済み',
  'tasks.addOptionBtn': '+ オプションを追加',
  'tasks.optionLabelLabel': 'オプションラベル',
  'tasks.optionDescLabel': '説明（任意）',
  'tasks.priceNoteLabel': '価格メモ（任意）',
  'tasks.titleLabel': 'タイトル *',
  'tasks.titlePlaceholderLabel': '例：タイル選択が必要',
  'tasks.descPlaceholderLabel': '必要な作業を説明してください...',
  'tasks.invoicePlaceholderLabel': '例：PC-003',
  'tasks.amountPlaceholderLabel': '例：35000',
  'tasks.taskTypeLabel': 'タスク種類',
  'tasks.assignToLabel': '担当者',
  'tasks.dueDateLabel': '期限',
  'tasks.descriptionLabel': '説明',
  'tasks.optionsLabel2': 'オプション',
  'tasks.invoiceNoLabel': '請求書番号',
  'tasks.amountLabel': '金額（$）',
  'tasks.paymentDueDateLabel': '支払期限',
  'tasks.newTaskTitle': '新規タスク',

  // Stages inline labels
  'stages.currentLabel': '現在',
  'stages.scheduleCompleteLabel': 'スケジュール完了',
  'stages.scheduleLabel': 'スケジュール',
  'stages.checklistFinalLabel': 'チェックリスト最終',
  'stages.noChecklistMappedLabel': 'チェックリスト未マッピング — スケジュールのみ',
  'stages.combinedProgressLabel': 'ステージ進捗（合計）',
  'stages.checklistFinalApprovalLabel': 'チェックリスト最終承認',
  'stages.paymentMilestonesLabel': '支払いマイルストーン',
  'stages.backToAllLabel': '全建設項目に戻る',
  'stages.oneOrMoreDelayedLabel': '1件以上の項目が遅延しています',
  'stages.notMappedLabel': 'チェックリスト未マッピング — 完了としてカウント',
  'stages.checklistCompleteLabel': 'チェックリスト完了',
  'stages.checklistIncompleteLabel': 'チェックリスト未完了',
  'stages.manuallyCompletedLabel': '手動完了',
  'stages.manualLabel': '手動 {pct}% — チェックリストなし',
  'stages.noScheduleItemsInStage': 'このステージにスケジュール項目がありません',
  'stages.checksLabel': '件のチェック',
  'stages.checklistItemsLabel': 'チェックリスト項目',
  'stages.completedLabel': '完了',
  'stages.delayedLabel': '遅延',
  'stages.atRiskLabel': 'リスク',
  'stages.completeLabel': '完了',
  'stages.mgmtPendingLabel': '管理保留',
  'stages.subPendingLabel': '下請業者保留',
  'stages.showingItemsLabel': '項目を表示中',
  'stages.updateStageBtn': 'ステージを更新',
  'stages.cancelBtn': 'キャンセル',
  'stages.suggestedCurrentStageLabel': '推奨現在ステージ',
  'stages.scheduleProgressSuggestsMoving': 'スケジュールの進捗により、このプロジェクトを {stage} に移動することを推奨します。',
  'stages.updateProjectStageBtn': 'プロジェクトステージを更新',
  'stages.dismissBtn': '閉じる',
  'stages.failedToLoadStages': 'ステージの読み込みに失敗しました',
  'stages.retryBtn': '再試行',
  'stages.noScheduleItemsYet': 'スケジュール項目なし',
  'stages.createScheduleFromTab': 'スケジュールタブからスケジュールを作成して、チェックリスト項目とリンクされたステージを確認してください。',
  'stages.formulaLabel': '計算式：スケジュール {sched}% x 50% + チェックリスト {cl}% x 50% = {combined}%',
  'stages.nilPayment': 'なし',

  // Schedule inline labels
  'schedule.refreshingData': 'スケジュールデータを更新中...',
  'schedule.loadingText': '読み込み中...',
  'schedule.retryBtn': '再試行',
  'schedule.dismissBtn': '閉じる',
  'schedule.updateProjectStageBtn': 'プロジェクトステージを更新',
  'schedule.scheduleProgressSuggestsMoving': 'スケジュールの進捗により、このプロジェクトを {stage} に移動することを推奨します。',
  'schedule.checklistFinalLabel': 'チェックリスト最終',
  'schedule.scheduleFinalLabel': 'スケジュール最終',
  'schedule.projectProgressLabel': 'プロジェクト進捗',
  'schedule.calculatedFrom50': 'チェックリスト50% + スケジュール50%から計算',
  'schedule.pendingCountLabel': '{count} 件保留中',
  'schedule.scheduleCompleteLabel': 'スケジュール完了',
  'schedule.showDetailsBtn': '詳細を表示',
  'schedule.hideDetailsBtn': '詳細を非表示',
  'schedule.reviewPendingItemsBtn': '保留中の項目を確認',
  'schedule.noChecklistMappingBtn': 'チェックリスト未マッピング',
  'schedule.incompleteChecklistBtn': '未完了チェックリスト',
  'schedule.markAllPendingBtn': '保留中の全スケジュール項目を完了にする',
  'schedule.noPendingItemsBtn': '保留中の項目なし',
  'schedule.hideChangeHistory': '変更履歴を非表示',
  'schedule.showChangeHistory': '変更履歴を表示',
  'schedule.noScheduleCreated': 'スケジュールがまだ作成されていません',
  'schedule.createFromDevTemplate': 'Buildertrend スケジュールテンプレートに基づいた156項目のデフォルト開発スケジュールを作成します。',
  'schedule.createFromDevTemplateBtn': '開発テンプレートからスケジュールを作成',
  'schedule.scheduleItemsNeedDatesDesc': '{count} 件のスケジュール項目が作成されましたが、タイムラインの日付がまだ設定されていません。',
  'schedule.generateInitialTimelineBtn': '初期タイムラインを生成',
  'schedule.noItemsMatchCurrentFilter': '現在のフィルターに一致するスケジュール項目がありません。',
  'schedule.clearFiltersBtn': 'フィルターをクリア',
  'schedule.setupInProgressTitle': 'スケジュールをインポートしました。セットアップ中です。',
  'schedule.setupInProgressDesc': 'クリティカルパスアラートを使用する前に、チェックリストのマッピングと進捗追跡を完了してください。',
  'schedule.projectProgressWillReach100': '保留中のスケジュール項目をすべて完了にすると、プロジェクト進捗が100%になります。',
  'schedule.markAllConfirmTitle': '保留中の全項目を完了にしますか？',
  'schedule.markAllConfirmDesc': '{count} 件のスケジュール項目を最終進捗100%で完了にします。すでに完了している項目は影響を受けません。',
  'schedule.markAllWarningText': 'この操作は簡単には元に戻せません。チェックリストのステータスに関わらず、保留中のすべてのスケジュール項目が完了に設定されます。',
  'schedule.markingLabel': 'マーク中...',
  'schedule.markCountCompleteBtn': '{count} 件を完了にする',
  'schedule.cancelBtn': 'キャンセル',
  'schedule.recalcCriticalPathTitle': 'クリティカルパスを再計算しますか？',
  'schedule.recalcCriticalPathDesc': '現在のスケジュール項目とリンクからクリティカルパスを計算し、is_critical フラグを Supabase に保存します。',
  'schedule.recalcCriticalPathWarning': '再計算後にクリティカルパスアラートが有効になります。クリティカルパス上にない項目のクリティカルフラグはクリアされます。',
  'schedule.calculatingLabel': '計算中...',
  'schedule.recalcAndSaveBtn': '再計算して保存',

  // Instructions inline labels
  'instructions.changeOrderLabel': '変更指示',
  'instructions.clientApprovalLabel': 'クライアント承認',
  'instructions.linkedScheduleLabel': 'リンクされたスケジュール',
  'instructions.linkedChecklistLabel': 'リンクされたチェックリスト',
  'instructions.linkedPhotoLabel': 'リンクされた写真',
  'instructions.changeOrderDetailsLabel': '変更指示の詳細',
  'instructions.reasonLabel': '理由',
  'instructions.currentLabel': '現在',
  'instructions.newLabel': '新しい',
  'instructions.costLabel': 'コスト',
  'instructions.scheduleLabel': 'スケジュール',
  'instructions.managementNoteLabel': '管理者メモ',
  'instructions.readMoreBtn': '続きを読む',
  'instructions.showLessBtn': '折りたたむ',
  'instructions.markCompletedBtn': '完了にする',
  'instructions.markClosedBtn': 'クローズにする',
  'instructions.acknowledgedLabel': '確認済み',
  'instructions.completedLabel': '完了',
  'instructions.readLabel': '既読',
  'instructions.noInstructionsYet': '指示書がまだありません',
  'instructions.createInstructionDesc': '下請業者に送る指示書を作成してください',
  'instructions.createChangeOrderBtn': '変更指示を作成',
  'instructions.createFirstInstructionBtn': '最初の指示書を作成',
  'instructions.changeOrderBtn': '変更指示',
  'instructions.newInstructionBtn': '新規指示書',

  // Payments inline labels
  'payments.title': '支払い',
  'payments.addPayment': '支払いを追加',
  'payments.editPayment': '支払いを編集',
  'payments.addFirstPayment': '最初の支払いを追加',
  'payments.addPaymentItem': '支払い項目を追加',
  'payments.noPaymentSchedule': '支払いスケジュールなし',
  'payments.addPaymentMilestones': 'このプロジェクトの支払いマイルストーンを追加してください',
  'payments.total': '合計',
  'payments.paid': '支払い済み',
  'payments.remaining': '残額',
  'payments.clientNotified': 'クライアントにポータルで通知済み',
  'payments.clientNotifiedPayment': 'クライアントが支払いを通知',
  'payments.confirmPaymentReceived': '支払い受領を確認',
  'payments.saveChanges': '変更を保存',
  'payments.cancel': 'キャンセル',
  'payments.delete': '削除',
  'payments.titleLabel': 'タイトル',
  'payments.descriptionLabel': '説明',
  'payments.amountLabel': '金額（NZD）',
  'payments.dueDateLabel': '期限',
  'payments.statusLabel': 'ステータス',
  'payments.paymentReferenceLabel': '支払い参照',
  'payments.paymentDateLabel': '支払い日',
  'payments.amountPaidLabel': '支払い金額',
  'payments.referenceLabel': '参照',
  'payments.noteLabel': 'メモ',
  'payments.optional': '（任意）',
  'payments.required': '*',
  'payments.upcoming': '予定',
  'payments.dueNowStatus': '支払い期限',
  'payments.overdueStatus': '期限超過',
  'payments.paidStatus': '支払い済み',
  'payments.pendingConfirmationStatus': '確認待ち',
  'payments.daysOverdue': '{n}日超過',
  'payments.dueToday': '本日期限',
  'payments.dueInDays': '{n}日後期限',
  'payments.reviewAndConfirm': 'クライアントが支払い完了を通知しました。以下で確認してください。',

  // Notification detail sheet
  'notifDetail.images': '枚の画像',
  'notifDetail.image': '枚の画像',
  'notifDetail.files': '件のファイル',
  'notifDetail.file': '件のファイル',

  // Tasks type/status/role labels
  'tasks.typeGeneral': '一般',
  'tasks.typeDecision': '決定',
  'tasks.typeSelection': '選択',
  'tasks.typePayment': '支払い',
  'tasks.typeApproval': '承認',
  'tasks.typeInformation': '情報',
  'tasks.statusPending': '保留',
  'tasks.statusAwaitingResponse': '返答待ち',
  'tasks.statusCompleted': '完了',
  'tasks.statusOverdue': '期限超過',
  'tasks.statusCancelled': 'キャンセル',
  'tasks.payStatusNA': 'N/A',
  'tasks.payStatusUnpaid': '未払い',
  'tasks.payStatusPartial': '一部払い',
  'tasks.payStatusPaid': '支払い済み',
  'tasks.payStatusOverdue': '期限超過',
  'tasks.roleManagement': '管理',
  'tasks.roleSubcontractor': '下請業者',
  'tasks.roleClient': 'クライアント',
  'tasks.roleAllParties': '全関係者',
  'tasks.filterAll': 'すべて',
  'tasks.filterOpen': '未完了',
  'tasks.filterDecision': '決定',
  'tasks.filterPayment': '支払い',
  'tasks.filterOverdue': '期限超過',
  'tasks.filterCompleted': '完了',

  // Stages status labels
  'stages.statusNotStarted': '未開始',
  'stages.statusInProgress': '進行中',
  'stages.statusCompleted': '完了',
  'stages.statusDelayed': '遅延',

  // Payments status labels
  'payments.statusUpcoming': '予定',
  'payments.statusDueNow': '支払い期限',
  'payments.statusOverdue': '期限超過',
  'payments.statusPaid': '支払い済み',
  'payments.statusPendingConfirmation': '確認待ち',

  // NewProject wizard additional keys
  'newProject.info': '情報',
  'newProject.type': '種類',
  'newProject.scheduleSetupStep': 'スケジュール設定',
  'newProject.cover': 'カバー',
  'newProject.team': 'チーム',
  'newProject.stagesStep': 'ステージ',
  'newProject.scheduleStep': 'スケジュール',
  'newProject.paymentsStep': '支払い',
  'newProject.review': '確認',
  'newProject.development': '開発',
  'newProject.renovation': 'リノベーション',
  'newProject.other': 'その他',
  'newProject.scheduleSource': 'スケジュールソース',
  'newProject.useDefaultTemplate': 'デフォルトテンプレートを使用',
  'newProject.copyFromExisting': '既存プロジェクトからコピー',
  'newProject.createScheduleLater': '後でスケジュールを作成',
  'newProject.createDefaultSchedule': 'デフォルトスケジュールを作成',
  'newProject.includeDependencyLinks': '依存関係リンクを含める',
  'newProject.generateInitialTimeline': '初期タイムラインを今すぐ生成',
  'newProject.scheduleStartDate': 'スケジュール開始日',
  'newProject.workingDays': '作業日',
  'newProject.workingDaysDesc': 'デフォルト：月〜土、日曜日とNZ祝日を除く。',
  'newProject.noTemplateSchedule': 'テンプレートスケジュールは作成されません。後でスケジュールタブから追加できます。',
  'newProject.selectProjectToCopy': 'スケジュールをコピーするプロジェクトを選択',
  'newProject.loadingProjects': 'プロジェクトを読み込み中...',
  'newProject.chooseExistingProject': '既存のプロジェクトを選択...',
  'newProject.scheduleItems': 'スケジュール項目',
  'newProject.pleaseSelectProject': 'スケジュールをコピーするプロジェクトを選択してください。',
  'newProject.noExistingProjects': 'スケジュールのある既存プロジェクトが見つかりません。',
  'newProject.sourceProjectSummary': 'ソースプロジェクトの概要',
  'newProject.loadingSummary': '概要を読み込み中...',
  'newProject.scheduleItemsLabel': 'スケジュール項目',
  'newProject.stagesLabel2': 'ステージ',
  'newProject.dependencyLinks': '依存関係リンク',
  'newProject.available': '利用可能',
  'newProject.notAvailable': '利用不可',
  'newProject.originalDateRange': '元の日付範囲',
  'newProject.checklistMappings': 'チェックリストマッピング',
  'newProject.couldNotLoadSummary': 'プロジェクトの概要を読み込めませんでした。',
  'newProject.copyOptions': 'コピーオプション',
  'newProject.copyScheduleItems': 'スケジュール項目をコピー',
  'newProject.copyStages': 'ステージをコピー',
  'newProject.copyDependencyLinks': '依存関係リンクをコピー',
  'newProject.copyChecklistMappings': 'チェックリストマッピングをコピー',
  'newProject.copyChecklistMappingsDesc': 'スケジュール項目とチェックリストが互換性がある場合のみ',
  'newProject.dateHandling': '日付処理',
  'newProject.generateTimelineFromStart': '新しいプロジェクト開始日からタイムラインを生成',
  'newProject.preservesDurations': '期間を保持し、開始/終了日を再計算',
  'newProject.newProjectStartDate': '新しいプロジェクト開始日',
  'newProject.useProjectStartDate': 'プロジェクト開始日を使用',
  'newProject.itemsCopiedWithDurationsOnly': '項目は期間のみでコピーされます。後でタイムラインを生成するまで開始/終了日は設定されません。',
  'newProject.completionStatusNotCopied': 'ソースプロジェクトの完了ステータスと実際の日付はコピーされません。新しいプロジェクトのスケジュールは新規に開始されます。',
  'newProject.noScheduleWillBeCreated': 'スケジュールは今すぐ作成されません。',
  'newProject.createOrImportLater': 'プロジェクト作成後、スケジュールタブからスケジュールを作成またはインポートできます。',
  'newProject.afterCreationScheduleTab': '作成後、スケジュールタブにはカスタムスケジュールの作成、テンプレートの適用、または別のプロジェクトからのコピーのオプションが表示されます。',
  'newProject.uploadOrLeaveBlank': '写真をアップロードするか、デフォルトのままにしてください',
  'newProject.coverPreview': 'カバープレビュー',
  'newProject.customPhoto': 'カスタム写真',
  'newProject.defaultCover': 'デフォルトカバー',
  'newProject.clickOrDragDrop': 'クリックまたはドラッグ＆ドロップでアップロード',
  'newProject.jpgPngWebp': 'JPG、PNG、WebP — 最大5MB',
  'newProject.uploading': 'アップロード中...',
  'newProject.orPasteUrl': 'またはURLを貼り付け',
  'newProject.coverPhotoUrl': 'カバー写真URL',
  'newProject.coverUrlPlaceholder': 'https://...（デフォルトを使用する場合は空白）',
  'newProject.resetToDefault': 'デフォルトカバーにリセット',
  'newProject.defaultCoversByType': 'プロジェクト種類別デフォルトカバー：',
  'newProject.developmentCoverDesc': '開発 — 木造フレーム / 新築建設画像',
  'newProject.renovationCoverDesc': 'リノベーション — 内装リモデル / キッチンリノベーション画像',
  'newProject.changeCoverAnytime': 'カバー写真はいつでもプロジェクト編集 → 種類とカバーから変更できます。',
  'newProject.optionalAddTeam': '任意 — 下請業者とクライアントを追加。後で追加することもできます。',
  'newProject.existingAccountsAdded': '既存のアカウントはすぐに追加されます',
  'newProject.ifEmailHasAccount': 'メールアドレスにアカウントがある場合、このプロジェクトに追加されます。新しいアカウントにはエッジ関数のデプロイが必要です。失敗した場合でも、プロジェクトは作成され、後でチームメンバーを追加できます。',
  'newProject.optionalSetTimeline': '任意 — 全体のプロジェクトタイムラインを設定。後で編集可能。',
  'newProject.stageDatesFromEdit': 'ステージごとの日付は、作成後にプロジェクト編集 → ステージから設定できます。',
  'newProject.monthsDuration': '{n}ヶ月の期間',
  'newProject.weeksDuration': '{n}週間の期間',
  'newProject.weekDuration': '{n}週間の期間',
  'newProject.daysDuration': '{n}日間の期間',
  'newProject.dayDuration': '{n}日間の期間',
  'newProject.setUpPaymentNow': '今すぐ支払いスケジュールを設定',
  'newProject.addLaterFromEdit': 'プロジェクト編集から後で追加することもできます',
  'newProject.noPaymentsAdded': '支払いがまだ追加されていません',
  'newProject.startFromTemplate': 'テンプレートから始めるか、手動で追加してください',
  'newProject.loadStandardTemplate': '標準テンプレートを読み込む',
  'newProject.addManually': '手動で追加',
  'newProject.payment': '支払い',
  'newProject.done': '完了',
  'newProject.titleRequired': 'タイトル',
  'newProject.descriptionOptional': '説明',
  'newProject.amountNZD': '金額（NZD）',
  'newProject.dueDate': '期限',
  'newProject.reference': '参照',
  'newProject.untitledPayment': '無題の支払い',
  'newProject.noAmountSet': '金額未設定',
  'newProject.addPaymentItem': '支払い項目を追加',
  'newProject.totalScheduled': '合計予定',
  'newProject.setUpPaymentLater': '支払いスケジュールは後でプロジェクト編集 → 支払いタブから設定できます。',
  'newProject.confirmDetails': '作成前にすべての詳細を確認してください',
  'newProject.projectCreatedSuccess': 'プロジェクトが正常に作成されました！',
  'newProject.noAddress': '住所なし',
  'newProject.projectDetailsSection': 'プロジェクト詳細',
  'newProject.projectNameLabel': 'プロジェクト名',
  'newProject.siteAddressLabel': '現場住所',
  'newProject.clientLabel': 'クライアント',
  'newProject.typeLabel': '種類',
  'newProject.startDateLabel': '開始日',
  'newProject.estCompletionLabel': '完了予定日',
  'newProject.notSet': '未設定',
  'newProject.scheduleSetupSection': 'スケジュール設定',
  'newProject.createDefaultFromTemplate': 'テンプレートからデフォルトスケジュールを作成',
  'newProject.includeDependencyLinksLabel': '依存関係リンクを含める',
  'newProject.generateTimelineFrom': '初期タイムラインを生成',
  'newProject.copyScheduleFromExisting': '既存プロジェクトからスケジュールをコピー',
  'newProject.copyScheduleItemsLabel': 'スケジュール項目をコピー',
  'newProject.copyStagesLabel': 'ステージをコピー',
  'newProject.copyDependencyLinksLabel': '依存関係リンクをコピー',
  'newProject.copyChecklistMappingsLabel': 'チェックリストマッピングをコピー',
  'newProject.recalculateDatesLabel': '新しい開始日から日付を再計算',
  'newProject.copyAsUndated': '日付なしスケジュールとしてコピー（期間のみ）',
  'newProject.noDefaultSchedule': 'デフォルトスケジュールなし — 後でスケジュールタブから追加できます',
  'newProject.stagesSection': 'ステージ',
  'newProject.teamSection': 'チーム',
  'newProject.paymentScheduleSection': '支払いスケジュール',
  'newProject.paymentItems': '件',
  'newProject.total': '合計',
  'newProject.noPaymentScheduleNote': '支払いスケジュールなし — 後でプロジェクト編集から追加できます',
  'newProject.readyToCreateDesc': '一意のプロジェクトコードが自動的に生成されます。プロジェクトはデータベースへの直接挿入によってすぐに作成されます。',
  'newProject.renovationTemplateNotConfigured': 'リノベーションスケジュールテンプレートはまだ設定されていません。',
  'newProject.canStillCreateProject': 'プロジェクトを作成し、後でスケジュールタブからスケジュールを設定することができます。',
  'newProject.customPhotoSet': 'カスタム写真設定済み',
  'newProject.autoUsedUnlessCustom': 'カスタムカバー写真をアップロードしない限り、この画像が自動的に使用されます。',
  'newProject.defaultCoverPhoto': 'デフォルトカバー写真',
  'newProject.defaultCoverLabel': '{type} デフォルトカバー',

  // New project creation result status
  'newProject.scheduleCreatedOk': 'スケジュールが正常に作成されました',
  'newProject.scheduleNotCreated': 'スケジュールは作成されませんでした — スケジュールタブから追加できます',
  'newProject.checklistCreatedOk': 'チェックリストが正常に作成されました',
  'newProject.checklistNotCreated': 'チェックリストの作成に失敗しました',
  'newProject.checklistNotCreatedDesc': 'プロジェクトを開いた後、チェックリストタブからデフォルトチェックリストを作成できます。',

  // Checklist setup in new project wizard
  'newProject.createDefaultChecklist': 'デフォルトチェックリストを作成',
  'newProject.createDefaultChecklistDesc': 'このプロジェクト種類のデフォルトチェックリストテンプレートをコピーします。',
  'newProject.createDefaultChecklistLaterDesc': 'デフォルトチェックリストテンプレートをコピーします。スケジュールは後で追加できます。',
  'newProject.createDefaultChecklistLabel': 'テンプレートからデフォルトチェックリストを作成',
  'newProject.linkChecklistToSchedule': 'チェックリストをスケジュールにリンク',
  'newProject.linkChecklistToScheduleDesc': 'ステージ/フェーズに基づいてチェックリスト項目をスケジュール項目にマッピングします。',
  'newProject.noTemplateScheduleChecklist': 'テンプレートスケジュールもチェックリストも作成されません。後でスケジュールとチェックリストタブから追加できます。',
  'newProject.copyChecklistItems': 'チェックリスト項目をコピー',
  'newProject.copyChecklistItemsDesc': 'ソースプロジェクトのすべてのチェックリスト項目をコピーし、未完了にリセットします。',
  'newProject.copyChecklistItemsLabel': 'チェックリスト項目をコピー',
  'newProject.resetChecklistCompletion': 'すべての完了状態をリセット',
  'newProject.resetChecklistCompletionDesc': 'コピーされたすべてのチェックリスト項目は未完了として開始されます。',
  'newProject.checklistsLabel': 'チェックリスト',
  'newProject.checklistItemsLabel': 'チェックリスト項目',
  'newProject.checklistItems': 'チェックリスト項目',

  // Checklist mobile labels
  'checklist.mgmtPending': '管理保留',
  'checklist.subPending': '下請業者保留',
  'checklist.pending': '保留中',
  'checklist.completed': '完了済み',

  // ChecklistItemCard keys
  'checklistCard.complete': '完了',
  'checklistCard.required': '必須',
  'checklistCard.mgmtPending': '管理保留',
  'checklistCard.subPending': '下請業者保留',
  'checklistCard.mgmt': '管理',
  'checklistCard.sub': '下請業者',
  'checklistCard.markAsIncomplete': '未完了にする',
  'checklistCard.markAsComplete': '完了にする',
  'checklistCard.completed': '完了',
  'checklistCard.awaitingMgmt': '管理者の確認待ち',
  'checklistCard.awaitingSubcontractor': '下請業者の確認待ち',
  'checklistCard.checkedRecently': '最近',
  'checklistCard.notes': 'メモ',
  'checklistCard.management': '管理',
  'checklistCard.subcontractor': '下請業者',

  // Instructions priority labels
  'priority.high': '高',
  'priority.medium': '中',
  'priority.low': '低',
  'priority.allPriorities': '全優先度',

  // Date/time formatting
  'date.today': '今日',
  'date.nonWorkday': '非作業日',
  'date.publicHoliday': '祝日',
  'date.offDay': '休日',
  'date.month': '月',
  'date.week': '週',
  'date.day': '日',

  // Notifications additional
  'notifications.markAsRead': '既読にする',
  'notifications.newNotification': '新しい通知',
  'notifications.emailSent': 'メール通知送信済み',
  'notifications.emailFailed': 'メール通知失敗',

  // Files additional
  'files.fileName': 'ファイル名',
  'files.fileType': 'ファイル種類',
  'files.uploadedBy': 'アップロード者',
  'files.uploadedDate': 'アップロード日',
  'files.visibleToClient': 'クライアントに表示',
  'files.managementOnly': '管理者のみ',
  'files.uploadFile': 'ファイルをアップロード',

  // Daily Log additional
  'dailyLog.uploadedBy': 'アップロード者',
  'dailyLog.uploadedDate': 'アップロード日',
  'dailyLog.reviewPhotos': '写真をレビュー',
  'dailyLog.pendingManagementReview': '管理者レビュー待ち',
  'dailyLog.approveForClientBtn': 'クライアント承認',
  'dailyLog.keepInternalBtn': '内部のみ',

  // Payments additional
  'payments.paymentSchedule': '支払いスケジュール',
  'payments.amount': '金額',
  'payments.paymentConfirmed': '支払い確認済み',
  'payments.awaitingConfirmation': '確認待ち',
  'payments.unpaid': '未払い',

  // Tasks additional
  'tasks.internalTask': '内部タスク',
  'tasks.clientTask': 'クライアントタスク',
  'tasks.priority': '優先度',
  'tasks.paymentTask': '支払いタスク',
  'tasks.decisionTask': '決定タスク',
  'tasks.generalTask': '一般タスク',

  // Checklist filter labels
  'checklist.filterAll': 'すべて',
  'checklist.filterUnchecked': '未チェック',
  'checklist.filterChecked': 'チェック済み',
  'checklist.filterWaitMgmt': '管理待ち',
  'checklist.filterWaitSub': '下請業者待ち',
  'checklist.filterFullyApproved': '完全承認',
  'checklist.filterUnmapped': '未マッピング',
  'checklist.checksCount': '件のチェック',
  'checklist.stageProgress': '{stage} の進捗',
  'checklist.mgmtLabel': '管理',
  'checklist.subLabel': '下請業者',
  'checklist.finalLabel': '最終',
  'checklist.paymentPercent': '{n}% 支払い',

  // Schedule hardcoded strings
  'schedule.refreshingScheduleData': 'スケジュールデータを更新中...',
  'schedule.scheduleProgressSuggestsMoving': 'スケジュールの進捗により、このプロジェクトを {stage} に移動することを推奨します。',
  'schedule.dismiss': '閉じる',
  'schedule.updateProjectStage': 'プロジェクトステージを更新',
  'schedule.checklistFinalColon': 'チェックリスト最終:',
  'schedule.scheduleFinalColon': 'スケジュール最終:',
  'schedule.projectProgressColon': 'プロジェクト進捗:',
  'schedule.calculatedFrom50Pct': 'チェックリスト50% + スケジュール50%から計算',
  'schedule.projectProgressWillReach': '保留中のスケジュール項目をすべて完了にすると、プロジェクト進捗が100%になります。',
  'schedule.scheduleCompleteAll': 'スケジュール最終: {pct}% — 全 {total} 件完了',
  'schedule.pendingItemsCount': '{count} 件のスケジュール項目が保留中',
  'schedule.noMappingIncomplete': '{count} 件の項目にチェックリストマッピングがなく、まだ未完了です。手動で完了するか、チェックリスト項目にマッピングしてください。',
  'schedule.incompleteLinkedChecklist': '{count} 件の項目にリンクされたチェックリストが未完了です。',
  'schedule.completedNotLinked': '{count} 件の完了済み項目がチェックリスト項目にリンクされていません。完了としてカウントされます。',
  'schedule.markAllPendingComplete': '保留中の全スケジュール項目を完了にする',
  'schedule.noPendingItems': '保留中の項目なし',
  'schedule.reviewPendingItemsBtn': '保留中の項目を確認',
  'schedule.noChecklistMappingBtn': 'チェックリスト未マッピング',
  'schedule.incompleteChecklistBtn': '未完了チェックリスト',
  'schedule.hideChangeHistory': '変更履歴を非表示',
  'schedule.showChangeHistory': '変更履歴を表示',
  'schedule.noScheduleCreatedDesc': 'Buildertrend スケジュールテンプレートに基づいた156項目のデフォルト開発スケジュールを作成します。',
  'schedule.createFromDevTemplateBtn': '開発テンプレートからスケジュールを作成',
  'schedule.scheduleItemsNeedDatesDesc': '{count} 件のスケジュール項目が作成されましたが、タイムラインの日付がまだ設定されていません。',
  'schedule.generateInitialTimelineBtn': '初期タイムラインを生成',
  'schedule.noItemsMatchCurrentFilter': '現在のフィルターに一致するスケジュール項目がありません。',
  'schedule.clearFiltersBtn': 'フィルターをクリア',
  'schedule.setupInProgressTitle': 'スケジュールをインポートしました。セットアップ中です。',
  'schedule.setupInProgressDesc': 'クリティカルパスアラートを使用する前に、チェックリストのマッピングと進捗追跡を完了してください。クリティカルパス分析はデフォルトで無効です。',
  'schedule.markAllConfirmTitle': '保留中の全項目を完了にしますか？',
  'schedule.markAllConfirmDesc': '{count} 件のスケジュール項目を最終進捗100%で完了にします。すでに完了している項目は影響を受けません。',
  'schedule.markAllWarningText': 'この操作は簡単には元に戻せません。チェックリストのステータスに関わらず、保留中のすべてのスケジュール項目が完了に設定されます。',
  'schedule.markingLabel': 'マーク中...',
  'schedule.markCountCompleteBtn': '{count} 件を完了にする',
  'schedule.cancelBtn': 'キャンセル',
  'schedule.recalcCriticalPathTitle': 'クリティカルパスを再計算しますか？',
  'schedule.recalcCriticalPathDesc': '現在のスケジュール項目とリンクからクリティカルパスを計算し、is_critical フラグを Supabase に保存します。',
  'schedule.recalcCriticalPathWarning': '再計算後にクリティカルパスアラートが有効になります。クリティカルパス上にない項目のクリティカルフラグはクリアされます。',
  'schedule.calculatingLabel': '計算中...',
  'schedule.recalcAndSaveBtn': '再計算して保存',
  'schedule.retryBtn': '再試行',

  // Instructions tab hardcoded strings
  'instructions.changeOrderBadge': '変更指示',
  'instructions.clientApprovalBadge': 'クライアント承認',
  'instructions.linkedScheduleBadge': 'リンクされたスケジュール',
  'instructions.linkedChecklistBadge': 'リンクされたチェックリスト',
  'instructions.linkedPhotoBadge': 'リンクされた写真',
  'instructions.changeOrderDetailTitle': '変更指示の詳細',
  'instructions.reasonColon': '理由：',
  'instructions.currentColon': '現在：',
  'instructions.newColon': '新しい：',
  'instructions.costColon': 'コスト：',
  'instructions.scheduleColon': 'スケジュール：',
  'instructions.managementNoteTitle': '管理者メモ',
  'instructions.readMoreBtn': '続きを読む',
  'instructions.showLessBtn': '折りたたむ',
  'instructions.markCompletedBtn': '完了にする',
  'instructions.markClosedBtn': 'クローズにする',
  'instructions.acknowledgedBadge': '確認済み',
  'instructions.completedBadge': '完了',
  'instructions.readBadge': '既読',
  'instructions.highPriorityBadge': '高優先度',
  'instructions.responseRequiredBadge': '返答必須',
  'instructions.changeOrderBtn2': '変更指示',
  'instructions.newInstructionBtn2': '新規指示書',
  'instructions.createChangeOrderBtn2': '変更指示を作成',
  'instructions.createFirstInstructionBtn2': '最初の指示書を作成',
  'instructions.noInstructionsYetMsg': '指示書がまだありません',
  'instructions.createInstructionMsg': '下請業者に送る指示書を作成してください',
  'instructions.noStatusInstructions': '{status} の指示書がありません',
  'instructions.toLabel': '宛先：',
  'instructions.dueLabel': '期限',

  // Notifications filter types
  'notifications.filterAll': 'すべて',
  'notifications.filterProgress': '進捗',
  'notifications.filterIssue': '問題',
  'notifications.filterApproval': '承認',
  'notifications.filterQuestion': '質問',
  'notifications.filterTask': 'タスク',
  'notifications.filterPayment': '支払い',
  'notifications.filterUpdate': '更新',
  'notifications.filterPhoto': '写真',
  'notifications.filterFile': 'ファイル',

  // Daily Log toast messages
  'dailyLog.toastTitleRequired': 'タイトルを入力して写真を選択してください',
  'dailyLog.toastCreatedSuccess': '日報が正常に作成されました',
  'dailyLog.toastCreateFailed': '日報の作成に失敗しました',

  // Daily Log created entries list
  'dailyLog.createdDailyLogs': '作成された日報',
  'dailyLog.untitledDailyLog': '無題の日報',
  'dailyLog.viewDailyLog': '日報を表示',
  'dailyLog.view': '表示',
  'dailyLog.previewAsClient': 'クライアント視点でプレビュー',
  'dailyLog.loadingDailyLogs': '日報を読み込み中...',

  // NewProject type descriptions
  'newProject.developmentDesc': '新築建設。土地開発、新築、集合住宅プロジェクトを含みます。',
  'newProject.renovationDesc': '既存構造のアップグレードまたはリモデル。全面改装、増築、フィットアウトを含みます。',
  'newProject.otherDesc': 'カスタムまたは複合用途プロジェクト。スケジュールは後でスケジュールタブから設定できます。',

  // Stages progress percent label
  'stages.progressPct': '{pct}% 進捗',
  'stages.paymentPercent': '{n}% 支払い',
  'stages.currentStageLabel': '現在のステージ',
  'stages.notSet': '未設定',
  'stages.setStageBtn': 'ステージを設定',
  'stages.noItemsYet': 'アイテムなし — 0%',
  'stages.moveToPrev': '前へ戻る',
  'stages.moveToNext': '次へ進む',
  'stages.movedToStageToast': 'プロジェクトを{stage}に移動しました',
  'stages.unassignedStage': '未割当',
  'stages.unassignedDesc': 'ステージ未設定のタスクです。スケジュールタブで割当ててください。ステージ進行をブロックしません。',
  'stages.moveAllToConstructionBtn': 'すべて施工に移動',
  'stages.movedUnassignedToConstructionToast': '{count}件のタスクを施工に移動しました',
  'stages.moveUnassignedFailed': '施工への移動に失敗しました。もう一度お試しください。',
  'stages.moveStageAnywayTitle': 'プロジェクトステージを移動しますか？',
  'stages.moveStageAnywayConfirm': '{stages}に未完了項目があります。{stage}に移動しますか？',
  'stages.moveStageAnywayBtn': '移動する',
  'stages.stageUpdateFailed': 'プロジェクトステージを更新できませんでした。もう一度お試しください。',
  'stages.checksCount': '{n} 件のチェック',
  'stages.checklistItemsCount': '{n} 件のチェックリスト項目',
  'stages.completedCount': '{n} 件完了',
  'stages.mgmtCount': '管理 {checked}/{total}',
  'stages.subCount': '下請業者 {checked}/{total}',

  // FileUploader shared component
  'upload.title': 'アップロード',
  'upload.takePhoto': '写真を撮影',
  'upload.choosePhotos': '写真を選択',
  'upload.uploadFile': 'ファイルをアップロード',
  'upload.dropFilesHere': 'ここにファイルをドロップ、またはクリックして選択',
  'upload.selectPhotos': '写真を選択',
  'upload.selectFiles': 'ファイルを選択',
  'upload.addCaption': 'キャプションを追加...',
  'upload.uploading': 'アップロード中…',
  'upload.retryFailed': '失敗を再試行',
  'upload.done': '完了',
  'upload.upload': 'アップロード',
  'upload.file': 'ファイル',
  'upload.files': 'ファイル',
  'upload.selected': '件選択中',
  'upload.uploaded': '件アップロード済み',
  'upload.closingMoment': 'まもなく閉じます…',
  'upload.fileTooLarge': 'が大きすぎます（最大 {max}）',
  'upload.totalExceeds': '合計アップロードサイズが {max} を超えています',
  'upload.maxFiles': '最大 {max} ファイルまで',
  'upload.notAnImage': 'は画像ではありません。写真のみ許可されています。',
  'upload.pdfNotAllowed': 'PDFのアップロードは許可されていません。',
  'upload.addCaptionFor': '{count} 件のファイルにキャプションを追加してください',
  'upload.addCaptionForPlural': '{count} 件のファイルにキャプションを追加してください',
  'upload.jpgPngWebpHeic': 'JPG、PNG、WebP、HEIC',
  'upload.jpgPngPdfDocs': 'JPG、PNG、PDF、ドキュメント',
  'upload.jpgPngDocs': 'JPG、PNG、ドキュメント',
  'upload.maxEach': '各最大 {max}',

  // PhotoLightbox
  'lightbox.pinchToZoom': 'ピンチでズーム · スワイプで移動',
  'lightbox.imageCouldNotLoad': '画像を読み込めませんでした',

  // ProjectDetail hardcoded strings
  'projectDetail.noAddressSet': '住所未設定',
  'projectDetail.description': '説明',
  'projectDetail.reviewPendingSchedule': '保留中のスケジュールを確認',
  'projectDetail.pendingScheduleItems': '{count} 件のスケジュール項目が保留中',
  'projectDetail.checklistItemsPending': '{count} 件のチェックリスト項目が保留中',
  'projectDetail.checklistFinalPct': 'チェックリスト最終: {pct}%',
  'projectDetail.scheduleFinalPct': 'スケジュール最終: {pct}%',
  'projectDetail.projectProgressPct': '{pct}% プロジェクト進捗',
  'projectDetail.scheduleFormula': 'スケジュール最終 {sched}% × 50% + チェックリスト最終 {cl}% × 50% = {total}% プロジェクト進捗',
  'projectDetail.checklistComplete100': 'チェックリストは100%完了しています。スケジュール最終が {schedPct}% のため、プロジェクト進捗は {pct}% で止まっています。',
  'projectDetail.progressFormula': 'プロジェクト進捗 = スケジュール最終50% + チェックリスト最終50%。100%に達するには、両方を完了してください。',
  'projectDetail.viewPendingItems': '保留中の項目を表示',
  'projectDetail.mgmtChecksComplete': '管理チェック完了。下請業者の確認待ちです。',
  'projectDetail.subPendingDesc': '{remaining} / {total} 件の下請業者必須チェックリスト項目が保留中です。',
  'projectDetail.scheduleProgressSuggestsMoving': 'スケジュールの進捗により、このプロジェクトを次のステージに移動することを推奨します',
  'projectDetail.updateProjectStage': 'プロジェクトステージを更新',
  'projectDetail.dismiss': '閉じる',

  // Checklist recovery flow
  'checklist.createDefaultChecklistForProject': 'このプロジェクトのデフォルトチェックリストを作成',
  'checklist.creatingDefaultChecklist': 'チェックリストを作成中...',
  'checklist.defaultChecklistCreated': '{count} 件の項目でデフォルトチェックリストを作成しました。',
  'checklist.defaultChecklistExists': 'このプロジェクトにはすでにチェックリストが存在します。',
  'checklist.failedToCreateDefault': 'デフォルトチェックリストの作成に失敗しました。再試行してください。',
  'checklist.checklistCreatedSuccess': 'チェックリストが正常に作成されました！',
  'checklist.checklistCreationFailed': 'チェックリストの作成に失敗しました',
  'checklist.checklistRecoveryNote': 'このプロジェクト種類のすべてのアクティブなチェックリストテンプレートが作成されます。',

  // Checklist by-section hardcoded strings
  'checklist.finalCompleteLabel': '最終：完了',
  'checklist.waitingForSubLabel': '下請業者待ち',
  'checklist.waitingForMgmtLabel': '管理待ち',
  'checklist.allItemsCheckedGreat': 'すべてのチェックリスト項目がチェックされました。お疲れ様です！',
  'checklist.viewCheckedItemsBtn': 'チェック済み項目を表示',

  // Notifications type badge
  'notifType.progress': '進捗',
  'notifType.issue': '問題',
  'notifType.inspection': '検査',
  'notifType.approval': '承認',
  'notifType.question': '質問',
  'notifType.task': 'タスク',
  'notifType.system': 'システム',
  'notifType.payment': '支払い',
  'notifType.update': '更新',
  'notifType.photo': '写真',
  'notifType.file': 'ファイル',
  'notifType.schedule': 'スケジュール',
  'notifType.instruction': '指示書',
  'notifType.checklist': 'チェックリスト',

  // Instructions page All filter
  'instructions.filterAll': 'すべて',

  // Daily Log note prefix
  'dailyLog.notePrefix': 'メモ:',
  'dailyLog.failedToSaveNote': 'メモの保存に失敗しました: ',
  'dailyLog.failedToDelete': '削除に失敗しました: ',
  'dailyLog.actionRequired': 'アクションが必要: ',

  // StagesTab progress label
  'stages.progressLabel': '{pct}% 進捗',
  'stages.paymentLabel': '{n}% 支払い',
  'stages.nilPaymentLabel': 'なし',

  // ScheduleItemModal
  'scheduleModal.editItem': 'スケジュール項目を編集',
  'scheduleModal.addItem': 'スケジュール項目を追加',
  'scheduleModal.basicInfo': '基本情報',
  'scheduleModal.datesProgress': '日付と進捗',
  'scheduleModal.linkedScheduleItems': 'リンクされたスケジュール項目',
  'scheduleModal.linkedChecklistItems': 'リンクされたチェックリスト項目',
  'scheduleModal.checklistCompletionSummary': 'チェックリスト完了概要',
  'scheduleModal.ganttBarColor': 'ガントバーの色',
  'scheduleModal.notesTask': 'メモとタスク',
  'scheduleModal.titleLabel': 'タイトル *',
  'scheduleModal.phaseLabel': 'フェーズ',
  'scheduleModal.stageLabel': 'ステージ',
  'scheduleModal.selectStage': '-- ステージを選択 --',
  'scheduleModal.constructionSubStage': '建設サブステージ',
  'scheduleModal.selectSubStage': '-- サブステージを選択 --',
  'scheduleModal.durationLabel': '期間（作業日）',
  'scheduleModal.assignedRole': '担当役割',
  'scheduleModal.assignedTo': '担当者',
  'scheduleModal.startDate': '開始日',
  'scheduleModal.endDate': '終了日',
  'scheduleModal.progressLabel': '進捗（%）',
  'scheduleModal.baselineStart': 'ベースライン開始',
  'scheduleModal.baselineEnd': 'ベースライン終了',
  'scheduleModal.actualStart': '実際開始',
  'scheduleModal.actualEnd': '実際終了',
  'scheduleModal.delayStatus': '遅延ステータス',
  'scheduleModal.riskLevel': 'リスクレベル',
  'scheduleModal.auto': '自動',
  'scheduleModal.complete': '完了',
  'scheduleModal.locked': 'ロック',
  'scheduleModal.noChecklist': 'チェックリストなし',
  'scheduleModal.includedInProject': 'プロジェクトに含む',
  'scheduleModal.criticalPath': 'クリティカルパス',
  'scheduleModal.notSet': '未設定',
  'scheduleModal.checklistProgress': 'チェックリスト進捗',
  'scheduleModal.completed': '完了',
  'scheduleModal.progress': '進捗',
  'scheduleModal.mgmtChecked': '管理チェック済み',
  'scheduleModal.subChecked': '下請業者チェック済み',
  'scheduleModal.missing': '未完了',
  'scheduleModal.totalLinked': 'リンク合計',
  'scheduleModal.mgmtChecksPending': '管理チェック保留中',
  'scheduleModal.subChecksPending': '下請業者チェック保留中',
  'scheduleModal.openLinkedChecklist': 'リンクされたチェックリストを開く',
  'scheduleModal.notesLabel': 'メモ',
  'scheduleModal.delayReason': '遅延理由',
  'scheduleModal.reasonForChange': '変更理由',
  'scheduleModal.reasonOptional': '（重要な変更に推奨）',
  'scheduleModal.publishToClient': 'スケジュール更新をクライアントに公開',
  'scheduleModal.publishDesc': 'チェックすると、クライアント向けのスケジュール更新がプロジェクト更新に投稿されます。',
  'scheduleModal.saving': '保存中...',
  'scheduleModal.saveChanges': '変更を保存',
  'scheduleModal.addItemBtn': '項目を追加',
  'scheduleModal.createTask': 'このスケジュール項目からタスクを作成',
  'scheduleModal.sendInstruction': '下請業者に指示書を送信',
  'scheduleModal.recalcDownstream': '下流を再計算しますか？',
  'scheduleModal.recalcDesc': 'この項目にはリンクされた後続項目があります。期間を変更すると日付がシフトします。下流項目を再計算しますか？',
  'scheduleModal.saveOnly': '保存のみ',
  'scheduleModal.saveAndRecalc': '保存して再計算',
  'scheduleModal.moveToNextWorkingDay': '次の作業日に移動',
  'scheduleModal.keepThisDate': 'この日付を保持',
  'scheduleModal.notWorkingDay': 'この日付（{day}）は現在のスケジュール設定に基づく作業日ではありません。',
  'scheduleModal.progressDerivedFromChecklist': '進捗はリンクされたチェックリストの完了状況から導出されます。',
  'scheduleModal.readyToComplete': '完了準備完了 — すべてのチェックリスト項目完了',
  'scheduleModal.notReady': '未準備 — {completed} / {total} 件のチェックリスト項目完了',
  'scheduleModal.mgmtChecksPendingDesc': '{count} 件のチェックリスト項目に管理承認が必要です',
  'scheduleModal.subChecksPendingDesc': '{count} 件のチェックリスト項目に下請業者承認が必要です',
  'scheduleModal.actionRequired': 'アクションが必要: ',
  'scheduleModal.deleteItem': 'スケジュール項目を削除',
  'scheduleModal.deleteItemTitle': 'スケジュール項目を削除しますか？',
  'scheduleModal.deleteItemConfirm': 'このスケジュール項目を削除してもよいですか？スケジュールから項目が削除され、依存関係のリンクもすべて削除されます。',
  'scheduleModal.deleteItemWarning': 'この操作は元に戻せません。すべてのリンクされた依存関係も削除されます。',
  'scheduleModal.deleteConfirmBtn': '項目を削除',
  'scheduleModal.cancelBtn': 'キャンセル',

  // Schedule mobile timeline/card labels
  'schedule.daySingular': '日',
  'schedule.dayPlural': '日',
  'schedule.linkSingular': 'リンク',
  'schedule.linkPlural': 'リンク',
  'schedule.noDate': '日付なし',
  'schedule.uncategorized': '未分類',
  'schedule.ganttSwipeHint': '横にスワイプしてガントチャート全体を確認できます。',

  // Stage names
  'stage.Planning': '計画',
  'stage.Design': '設計',
  'stage.Consent': '許可',
  'stage.Construction': '建設',
  'stage.Handover': '引き渡し',

  // Checklist empty state new keys
  'checklist.noChecklistItemsDesc': 'このプロジェクトにはまだチェックリスト項目がありません。',
  'checklist.refreshPage': 'ページを更新',
  'checklist.forceReload': 'チェックリストを強制再読み込み',
  'checklist.forceReloadChecklist': 'チェックリストデータを強制再読み込み',

  // ProjectDetail new keys
  'projectDetail.pending': '保留中',
  'projectDetail.reviewSchedule': 'スケジュール確認',
  'projectDetail.reviewChecklist': 'チェックリスト確認',
  'projectDetail.scheduleItemsPending': 'スケジュール項目保留中',
  'projectDetail.checklistItemsPendingShort': 'チェックリスト項目保留中',
  'projectDetail.waitingSubcontractor': '下請け待ち',
  'progress.currentStage': '現在のステージ',

  // PostUpdateModal
  'postUpdate.title': '更新を投稿',
  'postUpdate.postAs': '{role}として投稿',
  'postUpdate.posting': '投稿中...',
  'postUpdate.updateType': '更新種類',
  'postUpdate.allParties': '全関係者',
  'postUpdate.managementOnly': '管理者のみ',
  'postUpdate.mgmtAndSub': '管理者と下請業者',
  'postUpdate.enterTitle': 'タイトルを入力してください',
  'postUpdate.enterDetails': '詳細を入力してください',
  'postUpdate.titlePlaceholder': '例：キッチン建具設置完了',
  'postUpdate.details': '詳細',
  'postUpdate.detailsPlaceholder': '現場の進捗、問題、メモを説明してください...',
  'postUpdate.clientHighlight': 'クライアントハイライト',
  'postUpdate.clientHighlightDesc': 'クライアントポータルでこの更新を特集する',
  'postUpdate.currentStage': '現在のステージ',
  'postUpdate.justNow': 'たった今',

  // FilesTab feedback
  'files.deleteFileFailed': 'ファイルの削除に失敗しました',
  'files.fileDeleted': 'ファイルを削除しました',
  'files.updateVisibilityFailed': '表示設定の更新に失敗しました',
  'files.fileNowVisible': 'ファイルが表示されるようになりました',
  'files.fileHidden': 'ファイルを非表示にしました',
  'files.moveFileFailed': 'ファイルの移動に失敗しました',
  'files.movedToFolder': '{folder}に移動しました',
  'files.removedFromFolder': 'フォルダから削除しました',

  // ScheduleFilterDrawer
  'scheduleFilter.title': 'スケジュールフィルター',
  'scheduleFilter.searchTitle': 'タイトル検索',
  'scheduleFilter.searchPlaceholder': 'スケジュール項目を検索...',
  'scheduleFilter.status': 'ステータス',
  'scheduleFilter.stage': 'ステージ',
  'scheduleFilter.allStages': '全ステージ',
  'scheduleFilter.assignedTo': '担当者',
  'scheduleFilter.all': 'すべて',
  'scheduleFilter.dateRange': '日付範囲',
  'scheduleFilter.allDates': '全日付',
  'scheduleFilter.thisWeek': '今週',
  'scheduleFilter.thisMonth': '今月',
  'scheduleFilter.customRange': 'カスタム範囲',
  'scheduleFilter.to': '〜',
  'scheduleFilter.showExcluded': '除外項目を表示',
  'scheduleFilter.clearAll': 'すべてクリア',
  'scheduleFilter.applyFilter': 'フィルターを適用',
  'scheduleFilter.statusAll': 'すべて',
  'scheduleFilter.statusUnfinished': '未完了',
  'scheduleFilter.statusCompleted': '完了',
  'scheduleFilter.statusDelayed': '遅延',
  'scheduleFilter.statusAtRisk': 'リスク',

  // ScheduleCompletionBlockModal
  'completionBlock.allApprovalsComplete': 'すべての承認が完了',
  'completionBlock.manualCompletion': '手動完了',
  'completionBlock.cannotCompleteYet': 'まだ完了できません',
  'completionBlock.waitingForApprovals': '承認待ち',
  'completionBlock.noChecklist': 'このスケジュール項目にはリンクされたチェックリストがありません。',
  'completionBlock.noChecklistMgmtOnly': 'このスケジュール項目にはリンクされたチェックリストがありません。管理者のみ手動で完了にできます。',
  'completionBlock.mgmtPlusSub': '{mgmt} 件の管理 + {sub} 件の下請業者チェックが保留中',
  'completionBlock.subPending': '{sub} 件の下請業者{check}が保留中',
  'completionBlock.mgmtPending': '{mgmt} 件の管理{check}が保留中',
  'completionBlock.requiredApprovalsIncomplete': '必要な承認が完了していません',
  'completionBlock.check': 'チェック',
  'completionBlock.checks': 'チェック',
  'completionBlock.management': '管理',
  'completionBlock.subcontractor': '下請業者',
  'completionBlock.allDone': 'すべて完了',
  'completionBlock.pending': '保留中',
  'completionBlock.approvalUnits': '{completed} / {total} 承認ユニット',
  'completionBlock.allApprovalsReady': 'すべての必須チェックリスト承認が完了しました。このスケジュール項目を完了にする準備ができています。',
  'completionBlock.reasonForManual': '手動完了の理由',
  'completionBlock.reasonPlaceholder': '例：これはチェックリスト項目のないマイルストーンマーカーです...',
  'completionBlock.provideReason': 'この項目を手動で完了する前に理由を入力してください。',
  'completionBlock.cancel': 'キャンセル',
  'completionBlock.markComplete': '完了にする',
  'completionBlock.overrideComplete': '上書きして完了',
  'completionBlock.confirmOverride': '上書きを確認',

  // ScheduleSettingsModal
  'scheduleSettings.title': 'スケジュール設定',
  'scheduleSettings.workingDays': '作業日',
  'scheduleSettings.holidays': '祝日',
  'scheduleSettings.countryCode': '国コード',
  'scheduleSettings.countryPlaceholder': '例：NZ',
  'scheduleSettings.region': '地域',
  'scheduleSettings.regionPlaceholder': '例：Auckland',
  'scheduleSettings.save': '設定を保存',
  'scheduleSettings.saving': '保存中...',
  'scheduleSettings.cancel': 'キャンセル',
  'scheduleSettings.monday': '月',
  'scheduleSettings.tuesday': '火',
  'scheduleSettings.wednesday': '水',
  'scheduleSettings.thursday': '木',
  'scheduleSettings.friday': '金',
  'scheduleSettings.saturday': '土',
  'scheduleSettings.sunday': '日',

  // ScheduleHistoryDrawer
  'scheduleHistory.title': '変更履歴',
  'scheduleHistory.close': '履歴パネルを閉じる',
  'scheduleHistory.noHistory': '変更履歴はまだありません',
  'scheduleHistory.loadingHistory': '履歴を読み込み中...',

  // ScheduleItemModalChecklistSection
  'checklistSection.completeMgmtCheck': '管理チェックを完了',
  'checklistSection.completeSubCheck': '下請業者チェックを完了',

  // EditProject hardcoded strings
  'editProject.projectNotFound': 'プロジェクトが見つかりません。',
  'editProject.failedToSave': '変更の保存に失敗しました。',

  // NewProject additional hardcoded strings
  'newProject.scheduleSetupDesc': 'このプロジェクトのスケジュールとチェックリストの作成方法を選択してください',
  'newProject.copyDevTemplate': '156項目の開発テンプレートをこのプロジェクトにコピー',
  'newProject.copyRenovationTemplate': 'デフォルトのリノベーションスケジュールテンプレートをコピー',
  'newProject.copyActiveTemplate': 'このプロジェクト種類のアクティブなテンプレートをコピー',
  'newProject.includeDependencyLinksDesc': 'テンプレートから先行/後続関係をコピー',
  'newProject.generateTimelineDesc': '開始日に基づいてすべてのスケジュール項目の開始日を設定',
  'newProject.paymentScheduleDesc': '任意 — 支払いマイルストーンを設定。後で編集可能。',
  'newProject.projectNamePreview': 'プロジェクト名',
  'newProject.siteAddressPreview': '現場住所',

  // StageProgress
  'stageProgress.sitePlaceholder': '現場の状況を説明してください...',
  'stageProgress.stagePhotos': 'ステージ写真',
  'stageProgress.upload': 'アップロード',
  'stageProgress.stageUpdates': 'ステージ更新',
  'stageProgress.postUpdate': 'ステージ更新を投稿',
  'stageProgress.postUpdateBtn': '更新を投稿',
  'stageProgress.addPhotos': '写真を追加',
  'stageProgress.stageProgress': 'ステージ進捗',
  'stageProgress.photos': '枚の写真',
  'stageProgress.updates': '件の更新',
  'stageProgress.morePhotos': '+{n} 枚',
  'stageProgress.subcontractorReport': '下請業者レポート',
  'stageProgress.managementUpdate': '管理者更新',

  // FileRow
  'fileRow.moveToFolder': 'フォルダに移動',
  'fileRow.unhide': '表示',
  'fileRow.hide': '非表示',
  'fileRow.delete': '削除',
  'fileRow.noFolder': 'フォルダなし',
  'fileRow.deleteFile': 'このファイルを削除しますか？',
  'fileRow.deleteConfirm': 'このファイルを削除してもよいですか？',
  'fileRow.cancel': 'キャンセル',
  'fileRow.hidden': '非表示',

  // ScheduleChangeLogPanel
  'changeLog.noChanges': 'スケジュール変更がまだ記録されていません。',
  'changeLog.noMatchFilter': 'このフィルターに一致する変更がありません。',
  'changeLog.filterAll': 'すべて',
  'changeLog.filterDateChanges': '日付変更',
  'changeLog.filterDelays': '遅延',
  'changeLog.filterClientVisible': 'クライアント表示',
  'changeLog.filterCriticalPath': 'クリティカルパス',
  'changeLog.filterCompletion': '完了',
  'changeLog.clientVisible': 'クライアント表示',
  'changeLog.reason': '理由',
  'changeLog.linkedItemsRecalculated': '{n} 件のリンク項目を再計算',

  // ScheduleClientView
  'clientView.loadingSchedule': 'スケジュールを読み込み中...',
  'clientView.scheduleComingSoon': 'スケジュールは近日公開',
  'clientView.scheduleComingSoonDesc': 'Japan Homes がプロジェクトスケジュールを設定中です。準備ができたらここに表示されます。',
  'clientView.stageProgress': 'ステージ進捗',
  'clientView.constructionMilestones': '建設マイルストーン',
  'clientView.overallProgress': '全体進捗',
  'clientView.stagesCompleted': '{completed}/{total} ステージ完了',
  'clientView.expectedCompletion': '完了予定',
  'clientView.currentStage': '現在のステージ',
  'clientView.projectComplete': 'プロジェクト完了',
  'clientView.nextStage': '次のステージ',
  'clientView.estCompletion': '完了予定日',
  'clientView.original': '元の日付',
  'clientView.scheduleUpdate': 'スケジュール更新',
  'clientView.keyScheduleItems': '主要スケジュール項目',
  'clientView.upcomingWork': '今後の作業',
  'clientView.recentlyCompleted': '最近完了',
  'clientView.starts': '開始',
  'clientView.done': '完了',
  'clientView.scheduleLegend': 'スケジュール凡例',
  'clientView.legendCompleted': '完了',
  'clientView.legendCurrent': '現在',
  'clientView.legendUpcoming': '予定',
  'clientView.scheduleNote': 'これはプロジェクトの計画スケジュールです。Japan Homes は変更があればお知らせします。日程や進捗についてご質問があれば Japan Homes にお問い合わせください。',
  'clientView.expectedStart': '開始予定',
  'clientView.expectedEnd': '終了予定',
  'clientView.duration': '期間',
  'clientView.workingDays': '作業日',
  'clientView.progress': '進捗',
  'clientView.linkedStages': 'リンクされたステージ',
  'clientView.previous': '前',
  'clientView.next': '次',
  'clientView.update': '更新',
  'clientView.notes': 'メモ',
  'clientView.close': '閉じる',
  'clientView.completed': '完了',
  'clientView.upcoming': '予定',
  'clientView.paymentPercent': '{n}% 支払い',

  // ScheduleGanttEditModal
  'ganttEdit.moveItem': 'スケジュール項目を移動しますか？',
  'ganttEdit.resizeItem': 'スケジュール項目をリサイズしますか？',
  'ganttEdit.moving': '移動中',
  'ganttEdit.shiftingStart': '開始日を変更中',
  'ganttEdit.changingDuration': '期間を変更中',
  'ganttEdit.currentStart': '現在の開始日',
  'ganttEdit.currentEnd': '現在の終了日',
  'ganttEdit.newStart': '新しい開始日',
  'ganttEdit.newEnd': '新しい終了日',
  'ganttEdit.duration': '期間',
  'ganttEdit.workingDays': '作業日',
  'ganttEdit.hasSuccessors': 'この項目には {n} 件のリンクされた後続項目があります。',
  'ganttEdit.downstreamAffected': '{n} 件の下流項目が影響を受ける可能性があります。',
  'ganttEdit.someComplete': '影響を受けるリンク項目の一部はすでに完了しています。',
  'ganttEdit.recalcDownstream': 'すべての下流項目を再計算',
  'ganttEdit.itemComplete': 'このスケジュール項目は完了としてマークされています。日付を変更してもよいですか？',
  'ganttEdit.manualLock': 'この項目には手動日付ロックがあります。変更後もロックされたままになります。',
  'ganttEdit.saveAndUpdate': '保存してリンク項目を更新',
  'ganttEdit.saveOnly': 'この項目のみ保存',
  'ganttEdit.save': '保存',
  'ganttEdit.cancel': 'キャンセル',

  // ScheduleListView hardcoded strings
  'listView.allComplete': '全 {n} 件完了',
  'listView.notMappedComplete': '{n} 件未マッピングだが完了',
  'listView.pendingFinal': '最終保留中',
  'listView.noMappingIncomplete': 'マッピングなし + 未完了',
  'listView.incompleteChecklist': '未完了チェックリスト',
  'listView.mappedButComplete': 'マッピング済みだが完了',
  'listView.notMappedReason': '未マッピング — 完了にするにはクリック',
  'listView.pendingFinalReason': '最終保留中 — 完了にするにはクリック',
  'listView.inProgress': '進行中 ({pct}%)',
  'listView.checklistIncomplete': 'チェックリスト未完了',
  'listView.noChecklistLinked': 'このスケジュール項目にはリンクされたチェックリストがありません。自動的に100%に達するには、チェックリスト項目をこのスケジュール項目にマッピングしてください。または手動で完了にしてください。',
  'listView.linkedChecklistIncomplete': 'リンクされたチェックリスト項目が完全に承認されていません。自動完了を解除するには、すべての必須管理および下請業者チェックを完了してください。',
  'listView.progressLabel': '進捗',
  'listView.checklistItems': 'チェックリスト項目',
  'listView.progressDerivedFromChecklist': '進捗はリンクされたチェックリストの完了状況から導出されます。',
  'listView.noChecklistLinkedManual': 'チェックリストがリンクされていません。進捗は手動で設定されます。',
  'listView.start': '開始',
  'listView.end': '終了',
  'listView.duration': '期間',
  'listView.workingDays': '作業日',
  'listView.assigned': '担当',
  'listView.checklistCompletion': 'チェックリスト完了',
  'listView.mgmt': '管理',
  'listView.sub': '下請業者',
  'listView.mgmtPending': '管理保留',
  'listView.subPending': '下請業者保留',
  'listView.linkedChecklistItems': 'リンクされたチェックリスト項目',
  'listView.baselineStart': 'ベースライン開始',
  'listView.baselineEnd': 'ベースライン終了',
  'listView.criticalPath': 'クリティカルパス',
  'listView.criticalPathYes': 'はい — 遅延は完了に影響します',
  'listView.delay': '遅延',
  'listView.delayDays': '{n} 日',
  'listView.dependencies': '依存関係',
  'listView.remove': '削除',
  'listView.editItem': '項目を編集',
  'listView.addLink': 'リンクを追加',
  'listView.sendInstruction': '指示書を送信',
  'listView.deleteItem': '削除',
  'listView.blockingProgress': '進捗をブロック中',
  'listView.notMapped': '未マッピング',
  'listView.manualComplete': '手動完了',
  'listView.noChecklist': 'チェックリストなし',
  'listView.waitingForSub': '下請業者待ち',
  'listView.finalComplete': '最終：完了',
  'listView.markComplete': '完了にする',
  'listView.completed': '完了',
  'listView.incomplete': '未完了',

  // ScheduleGanttView hardcoded strings
  'ganttView.useWeekView': '正確な日付編集には日次または週次ビューを使用してください',
  'ganttView.includeAll': 'すべての項目を含める',
  'ganttView.excludeAll': 'すべての項目を除外',
  'ganttView.criticalPath': 'クリティカルパス',
  'ganttView.excluded': '除外',
  'ganttView.final': '最終',
  'ganttView.done': '完了',
  'ganttView.complete': '完了',
  'ganttView.today': '今日',
  'ganttView.excluded2': '除外済み',
  'ganttView.noDateAssigned': '日付未設定',
  'ganttView.hiddenLink': '非表示リンク',
  'ganttView.criticalPathNotCalc': 'クリティカルパスがまだ計算されていません',
  'ganttView.criticalPathDesc': 'クリティカルパスは、プロジェクトのタイムラインに直接影響するタスクのシーケンスを特定します。',
  'ganttView.calculateCriticalPath': 'クリティカルパスを計算',

  // ScheduleToolbar hardcoded strings
  'toolbar.list': 'リスト',
  'toolbar.gantt': 'ガント',
  'toolbar.day': '日',
  'toolbar.week': '週',
  'toolbar.month': '月',
  'toolbar.year': '年',
  'toolbar.wideZoom': 'ワイド',
  'toolbar.comfortableZoom': '標準',
  'toolbar.compactZoom': 'コンパクト',
  'toolbar.miniZoom': 'ミニ',
  'toolbar.today': '今日',
  'toolbar.regenerate': '再生成',
  'toolbar.importPdf': 'PDF インポート',
  'toolbar.filter': 'フィルター',
  'toolbar.filterActive': 'フィルター有効',
  'toolbar.phases': 'フェーズ',
  'toolbar.critical': 'クリティカル',
  'toolbar.enableCritical': 'クリティカルを有効化',
  'toolbar.fullscreen': 'フルスクリーン',
  'toolbar.exit': '終了',
  'toolbar.more': 'その他',
  'toolbar.allStages': '全ステージ',
  'toolbar.allSubStages': '全サブステージ',
  'toolbar.clearStageFilters': 'ステージフィルターをクリア',
  'toolbar.statusAll': 'すべて',
  'toolbar.statusPending': '最終保留中',
  'toolbar.statusDone': '最終100%',
  'toolbar.statusNoCL': 'チェックリストなし',
  'toolbar.statusIncCL': '未完了チェックリスト',
  'toolbar.statusPendingMobile': '保留中',
  'toolbar.statusDoneMobile': '完了',
  'toolbar.statusNoCLMobile': 'CL なし',
  'toolbar.statusIncCLMobile': '未完了 CL',
  'toolbar.statusLabel': 'ステータス',
  'toolbar.selected': '件選択中',
  'toolbar.selectAll': '表示中の全項目を選択',
  'toolbar.selectAllMobile': 'すべて',
  'toolbar.clear': 'クリア',
  'toolbar.markAllPending': '保留中をすべて完了',
  'toolbar.markSelected': '選択項目を完了',
  'toolbar.markAllPendingMobile': 'すべて',
  'toolbar.completeMobile': '完了',
  'toolbar.pendingItems': '{n} 件保留中',
  'toolbar.scheduleOnline': 'スケジュールオンライン',
  'toolbar.comingSoon': '近日公開',
  'toolbar.exportPdfCsv': 'PDF / CSV にエクスポート',
  'toolbar.scheduleHistory': 'スケジュール履歴',
  'toolbar.addScheduleItem': 'スケジュール項目を追加',
  'toolbar.hideAllLinks': 'すべてのリンクを非表示',
  'toolbar.showAllLinks': 'すべてのリンクを表示',
  'toolbar.visibility': '表示設定',
  'toolbar.hideExcluded': '除外項目を非表示',
  'toolbar.showExcluded': '除外項目を表示',
  'toolbar.includeAll': '全 {n} 件を含める',
  'toolbar.excludeAll': 'すべての項目を除外',
  'toolbar.actions': 'アクション',
  'toolbar.regenerateTimeline': 'タイムラインを再生成',
  'toolbar.createTimeline': 'タイムラインを作成',
  'toolbar.importBuildertrend': 'Buildertrend PDF をインポート',
  'toolbar.recalcProgress': '進捗を再計算',
  'toolbar.recalcCriticalPath': 'クリティカルパスを再計算',
  'toolbar.recalcLinkedItems': 'リンク項目を再計算',
  'toolbar.setBaseline': 'ベースラインを設定',
  'toolbar.resetCriticalPath': 'クリティカルパスフラグをリセット',
  'toolbar.debugInfo': 'デバッグ情報',
  'toolbar.hideSummary': 'サマリーを非表示',
  'toolbar.showSummary': 'サマリーを表示',
  'toolbar.hideLinks': 'リンクを非表示',
  'toolbar.showLinks': 'リンクを表示',
  'toolbar.hidePhases': 'フェーズを非表示',
  'toolbar.showPhases': 'フェーズを表示',
  'toolbar.allItems': 'すべての項目',
  'toolbar.criticalPathOnly': 'クリティカルパス',
  'toolbar.hideExcludedMobile': '除外を非表示',
  'toolbar.showExcludedMobile': '除外を表示',
  'toolbar.refresh': '更新',
  'toolbar.addItem': '項目を追加',
  'toolbar.clearFilter': 'クリア',
  'toolbar.marking': 'マーク中...',
  'toolbar.markAllPendingComplete': '保留中の全項目を完了にする',
  'toolbar.copyGanttColors': '5 Methuen Roadからガントバーカラーをコピー',

  // Copy Gantt Colors modal
  'schedule.copyColorsConfirmTitle': '5 Methuen Roadのガントカラーをコピーしますか？',
  'schedule.copyColorsConfirmDesc': 'タスク番号、タイトル、またはスケジュール順序で一致させて、5 Methuen Roadのガントバーカラーをこのプロジェクトにコピーします。bar_colorのみ変更されます — 日程、進捗、完了状態は変更されません。',
  'schedule.copyColorsWarningText': 'このプロジェクトの既存のカスタムバーカラーは上書きされます。',
  'schedule.copyColorsBtn': 'カラーをコピー',
  'schedule.copyingColorsLabel': 'コピー中...',
  'schedule.dismissResult': '閉じる',
  'files.newFileUploaded': '新しいファイルがアップロードされました',

  // PaymentsTab notification
  'payments.mgmtConfirmedReceipt': '管理者がお支払いの受領を確認しました。',

  // PhotosTab notifications
  'photos.newPhotosAdded': '新しいプロジェクト写真がギャラリーに追加されました。',
  'photos.newPhotosAddedClient': '新しいプロジェクト写真があなたのプロジェクトギャラリーに追加されました。',
  'photos.photoNotFound': '写真が見つかりません',
  'photos.deleteFailed': '削除に失敗しました',

  // TasksTab notification
  'tasks.clientMarkedPaid': 'クライアントがこの支払いを支払い済みとしてマークしました。',
  'tasks.mgmtConfirmedReceipt': '管理者がお支払いの受領を確認しました。',

  // Date locale
  'date.locale': 'ja-JP',
  'date.localeShort': 'ja',

  // Change Orders module
  'nav.changeOrders': '変更指示',
  'nav.scheduleTemplates': 'スケジュールテンプレート',
  'templates.pageTitle': 'スケジュールテンプレート管理',
  'templates.pageDesc': '新規プロジェクト作成時に使用する開発・リノベーションのスケジュールテンプレートを管理します。',
  'templates.pageDescMulti': 'プロジェクト種別ごとに複数のスケジュールテンプレートを管理します。変更は新規プロジェクトにのみ適用されます。',
  'templates.createTemplate': '新規テンプレート',
  'templates.create': '作成',
  'templates.filterAll': 'すべて',
  'templates.emptyList': 'スケジュールテンプレートがありません。',
  'templates.emptyListHint': '新規プロジェクト用のパターンを定義するにはテンプレートを作成してください。',
  'templates.emptyFilter': 'このプロジェクト種別のテンプレートはありません。',
  'templates.untitledTemplate': '無題のテンプレート',
  'templates.defaultBadge': 'デフォルト',
  'templates.draftBadge': '下書き',
  'templates.activeBadge': '有効',
  'templates.itemCount': '{count} タスク',
  'templates.linkCount': '{count} リンク',
  'templates.updatedAt': '更新 {date}',
  'templates.edit': '編集',
  'templates.duplicate': '複製',
  'templates.exportCsv': 'CSVエクスポート',
  'templates.setDefault': 'デフォルトに設定',
  'templates.archive': 'アーカイブ',
  'templates.delete': '削除',
  'templates.importCsv': 'CSVインポート',
  'templates.importComingSoon': 'CSVインポートは今後の更新で対応予定です。',
  'templates.duplicatePrompt': '複製テンプレート名',
  'templates.duplicated': 'テンプレートを複製しました。',
  'templates.defaultSet': 'デフォルトテンプレートを更新しました。',
  'templates.archiveConfirm': '「{name}」をアーカイブしますか？',
  'templates.archived': 'テンプレートをアーカイブしました。',
  'templates.archiveDisabledDefault': 'これはデフォルトの{projectType}テンプレートです。アーカイブする前に別の{projectType}テンプレートを作成し、デフォルトに設定してください。',
  'templates.archiveDisabledDefaultWithTasks': 'これはデフォルトの{projectType}テンプレートです。アーカイブする前に別の{projectType}テンプレートをデフォルトに設定してください。',
  'templates.archiveDisabledEmptyDefault': 'この空のテンプレートはデフォルトに設定されています。タスクを追加するか、別のテンプレートをデフォルトに設定するか、未使用なら削除してください。',
  'templates.archiveDisabledOnlyTemplate': 'アーカイブする前に別の{projectType}テンプレートを作成し、デフォルトに設定してください。',
  'templates.draftHelp': '下書きテンプレートはタスクが追加されデフォルトに設定されるまで、新規プロジェクトでは使用されません。',
  'templates.setDefaultNeedsTasks': 'デフォルトに設定する前に、少なくとも1つのタスクを追加してください。',
  'templates.deleteEmptyConfirm': 'この空のテンプレートを削除しますか？元に戻せません。',
  'templates.createdAsDraft': '下書きとしてテンプレートを作成しました。デフォルトにする前にタスクを追加してください。',
  'templates.savedAsDraft': '下書きとして保存しました。デフォルトにする前にタスクを追加してください。',
  'templates.deleteConfirm': '「{name}」を完全に削除しますか？',
  'templates.deleted': 'テンプレートを削除しました。',
  'templates.created': 'テンプレートを作成しました。',
  'templates.newTemplateNamePlaceholder': '例: Development B Pattern',
  'templates.saved': 'テンプレートを保存しました。',
  'templates.saving': '保存中…',
  'templates.searchItems': 'タスクを検索…',
  'templates.noSearchResults': '一致するタスクがありません。',
  'templates.sortOrder': '順序',
  'newProject.selectScheduleTemplate': 'スケジュールテンプレート',
  'newProject.renovationScheduleMode': 'リノベーションスケジュール',
  'newProject.renovationModeLight': 'ライトスケジュール（11タスク）',
  'newProject.renovationModeTemplate': 'テンプレートライブラリから',
  'newProject.renovationModeBlank': '空白 / 手動',
  'newProject.renovationModeBlankDesc': 'スケジュールは作成されません。作成後に手動で追加してください。',
  'newProject.tasksLabel': 'タスク',
  'templates.developmentTemplate': '開発テンプレート',
  'templates.developmentTemplateDesc': 'Buildertrendベースのデフォルト開発スケジュールテンプレート。',
  'templates.renovationTemplate': 'リノベーションテンプレート',
  'templates.renovationTemplateDesc': 'デフォルトのリノベーションスケジュールテンプレート。',
  'templates.editorPending': 'テンプレートエディターは未実装です。新規プロジェクト作成時には引き続きテンプレートを適用できます。',
  'templates.editorTitleDevelopment': 'Development Schedule Template',
  'templates.editorTitleRenovation': 'Renovation Schedule Template',
  'templates.templateName': 'テンプレート名',
  'templates.templateType': 'テンプレート種別',
  'templates.stagesTasksList': 'ステージ / タスク',
  'templates.addStageTask': 'ステージ / タスクを追加',
  'templates.editStageTask': '編集',
  'templates.deleteStageTask': '削除',
  'templates.applyEdit': '適用',
  'templates.taskTitle': 'タスク名',
  'templates.phase': 'フェーズ / ステージ',
  'templates.durationDays': '工期（日）',
  'templates.days': '日',
  'templates.untitledTask': '無題のタスク',
  'templates.noItems': 'このテンプレートにはまだステージやタスクがありません。',
  'templates.loading': 'テンプレートを読み込み中…',
  'templates.loadError': 'テンプレートの読み込みに失敗しました',
  'templates.saveNotConnected': 'Save function is not connected yet',
  'templates.templateLinksHeading': 'テンプレートリンク ({count})',
  'templates.addLink': 'リンク追加',
  'templates.searchLinks': 'タスク名でリンクを検索…',
  'templates.predecessor': '先行タスク',
  'templates.successor': '後続タスク',
  'templates.chooseTask': 'タスクを選択…',
  'templates.lagDays': 'ラグ日数',
  'templates.addDependency': '依存関係を追加',
  'templates.linksNeedTwoTasks': 'リンクを作成する前に、2つ以上のテンプレートタスクを保存してください。',
  'templates.noLinksYet': 'テンプレートリンクはまだありません。',
  'templates.noLinkSearchResults': '検索に一致するリンクがありません。',
  'templates.linkCountBadge': '{count}件のリンク',
  'templates.unknownTask': '不明なタスク',
  'templates.ganttView': 'ガント表示',
  'templates.listView': 'リスト表示',
  'templates.linkTypeLabel': 'タイプ',
  'templates.lagLabel': 'ラグ',
  'templates.predecessorLinks': '先行タスク',
  'templates.successorLinks': '後続タスク',
  'templates.noPredecessorLinks': 'このタスクの先行リンクはありません。',
  'templates.noSuccessorLinks': 'このタスクの後続リンクはありません。',
  'templates.ganttSyntheticHint': 'タスク順・工期・依存関係から算出した合成タイムライン（Day 1, Day 2…）です。',
  'templates.ganttSelectTask': 'タスクバーをクリックしてリンクを確認・編集します。',
  'templates.ganttSelectedTask': '選択中のタスク',
  'templates.ganttAddSuccessor': '後続リンクを追加',
  'templates.ganttAddPredecessor': '先行リンクを追加',
  'templates.ganttLinkCounts': '入/出リンク',
  'templates.templateGanttComingSoon': 'テンプレートガント表示は次回対応予定です。グループ化リンクエディタをご利用ください。',
  'co.pageTitle': '変更指示',
  'co.pageSubtitle': 'クライアントまたは下請業者の承認が必要な仕様変更を管理します',
  'co.create': '新規変更指示',
  'co.items': '件',
  'co.readMore': '続きを読む',
  'co.showLess': '折りたたむ',
  'co.clientComment': 'クライアントコメント',
  'co.viewInProject': 'プロジェクトで表示',
  'co.lockedTooltip': 'この変更指示はロックされています（承認済み/クローズ）',
  'co.lockedMessage': 'ロック済み — 承認済み・クローズ済みの変更指示は編集できません。修正が必要な場合は新規変更指示を作成してください。',
  'co.status.draft': '下書き',
  'co.status.pendingApproval': '承認待ち',
  'co.status.sentToClient': '承認待ち',
  'co.status.approved': '承認済み',
  'co.status.clientApproved': '承認済み',
  'co.status.rejected': '却下',
  'co.status.clientRejected': '却下',
  'co.status.closed': 'クローズ',
  'co.status.inProgress': '進行中',
  'co.status.completed': '完了',
  'co.status.cancelled': 'キャンセル',
  'co.filter.all': 'すべて',
  'co.filter.pendingClient': '承認待ち',
  'co.filter.approved': '承認済み',
  'co.filter.rejected': '却下',
  'co.filter.draft': '下書き',
  'co.filter.closed': 'クローズ',
  'co.filter.inProgress': '進行中',
  'co.filter.completed': '完了',
  'co.stats.total': '合計',
  'co.stats.pendingClient': '承認待ち',
  'co.stats.approved': '承認済み',
  'co.stats.draft': '下書き',
  'co.alert.pendingClientApproval': '件の変更指示がクライアント承認待ちです',
  'co.alert.pendingClientDesc': 'クライアントに通知済みです。確認待ちの状態です。',
  'co.badge.clientApproval': 'クライアント承認',
  'co.badge.clientApproved': 'クライアント承認済み',
  'co.badge.clientDeclined': 'クライアント却下',
  'co.clientPortal.visible': 'クライアントに表示',
  'co.clientPortal.autoVisible': 'クライアントに表示',
  'co.clientPortal.hidden': 'クライアント非表示',
  'co.clientPortal.draft': '下書き（非表示）',
  'co.clientPortal.shareWithClient': 'クライアントに共有',
  'co.clientPortal.hideFromClient': 'クライアントから非表示',
  'co.details.title': '変更指示の詳細',
  'co.details.reason': '理由：',
  'co.details.currentFinish': '現在：',
  'co.details.newFinish': '新しい：',
  'co.details.costImpact': 'コスト：',
  'co.details.scheduleImpact': 'スケジュール：',
  'co.action.sendToClient': 'クライアントへ送付',
  'co.action.markApproved': '承認済みにする',
  'co.action.markRejected': '却下にする',
  'co.action.markCompleted': '完了にする',
  'co.action.close': 'クローズ',
  'co.action.cancel': 'キャンセル',
  'co.action.edit': '変更指示を編集',
  'co.action.revertToDraft': '下書きに戻す',
  'co.internal.title': '内部情報（クライアントには非表示）',
  'co.internal.builderCost': '施工費用',
  'co.internal.clientPrice': 'クライアント請求額',
  'co.internal.margin': '利益',
  'co.clientDesc.label': 'クライアント説明',
  'co.form.createTitle': '新規変更指示',
  'co.form.editTitle': '変更指示を編集',
  'co.form.titleLabel': 'タイトル',
  'co.form.titlePlaceholder': '例：キッチンタイルのアップグレード',
  'co.form.descriptionLabel': '内部説明',
  'co.form.descriptionPlaceholder': '内部メモ（クライアントには非表示）...',
  'co.form.clientDescLabel': 'クライアント説明',
  'co.form.clientDescPlaceholder': 'クライアントに表示する説明...',
  'co.form.reasonLabel': '変更理由',
  'co.form.reasonPlaceholder': '例：クライアントからのアップグレード要求',
  'co.form.currentFinishLabel': '現在の仕様',
  'co.form.currentFinishPlaceholder': '例：標準300×300タイル',
  'co.form.newFinishLabel': '新しい仕様',
  'co.form.newFinishPlaceholder': '例：600×600磁器タイル',
  'co.form.scheduleImpactLabel': 'スケジュールへの影響',
  'co.form.scheduleImpactPlaceholder': '例：+3作業日',
  'co.form.builderCostLabel': '施工費用（NZD）',
  'co.form.clientPriceLabel': 'クライアント請求額（NZD）',
  'co.form.internalNoteLabel': '内部メモ',
  'co.form.internalNotePlaceholder': 'PM専用メモ（仕入先、利益率メモ等）...',
  'co.form.statusLabel': 'ステータス',
  'co.form.requiresClientApproval': 'クライアント承認が必要',
  'co.form.internalOnly': '内部のみ',
  'co.form.clientVisible': 'クライアント表示',
  'co.form.saveChanges': '変更を保存',
  'co.form.create': '作成',
  'co.empty.title': '変更指示がまだありません',
  'co.empty.desc': '変更指示は、仕様・コスト・スケジュールの変更を記録するために使用します。',
  'tabs.changeOrders': '変更指示',

  // ── Layout additions (Client / Subcontractor) ──
  'nav.myProject': 'マイプロジェクト',
  'nav.payments': '支払い',
  'nav.questions': '質問',
  'role.clientPortal': 'クライアントポータル',
  'role.subcontractor': '下請業者',
  'user.client': 'クライアント',
  'user.subcontractor': '下請業者',

  // ── Relative time (weeks) ──
  'notifications.weekAgo': '{n}週間前',
  'notifications.weeksAgo': '{n}週間前',

  // ── Notification type translations (title prefix + body) ──
  'notif.type.daily_log_created': '新しい日報',
  'notif.type.instruction_created': '新しい指示',
  'notif.type.change_order_approved': 'クライアントが変更依頼「{title}」を承認しました',
  'notif.type.schedule_recalculated': 'スケジュールを再計算しました',
  'notif.type.critical_path_delayed': 'クリティカルパス項目が遅延しています: {title}',
  'notif.type.payment_confirmed': '支払い確認済み',
  'notif.type.photo_uploaded': '新しい写真がアップロードされました',
  'notif.type.file_uploaded': '新しいファイルがアップロードされました',
  'notif.type.question_asked': '新しい質問',
  'notif.type.update_posted': '新しい更新情報',
  'notif.type.task_created': '新しいタスク',
  'notif.type.checklist_updated': 'チェックリストが更新されました',

  // ── Notification body translations ──
  'notif.body.schedule_recalculated': '依存関係の変更に基づき、関連するスケジュール項目を再計算しました。',
  'notif.body.critical_path_delayed': '遅延しています。完了予定日は {date} です。',
  'notif.body.change_order_approved': 'クライアントが変更依頼を承認しました。',
  'notif.body.payment_confirmed': '管理者がお支払いの受領を確認しました。',
  'notif.body.client_marked_paid': 'クライアントがこの支払いを支払い済みとしてマークしました。',

  // ── Empty states (Part 6) ──
  'checklist.noChecklistItemsEmpty': 'チェックリスト項目がありません',
  'checklist.createDefaultForProject': 'このプロジェクトの標準チェックリストを作成',
  'story.noEventsYet': 'ストーリーイベントはまだありません',
  'story.addEvent': 'イベントを追加',
  'schedule.generateInitialTimelineBtn2': '初期タイムラインを生成',
  'schedule.hideDetailsBtn2': '詳細を閉じる',
  'schedule.showDetailsBtn2': '詳細を表示',
  'schedule.markAllPendingCompleteBtn': '保留中のスケジュール項目をすべて完了にする',
  'schedule.reviewPendingItemsBtn2': '保留項目を確認',
  'schedule.noChecklistMappingLabel': 'チェックリスト未連携',
  'schedule.pendingScheduleItemsCount': '{count}件のスケジュール項目が保留中',

  // ScheduleTab status summary
  'schedule.statusHideDetails': '詳細を閉じる',
  'schedule.statusShowDetails': '詳細を表示',
  'schedule.notMappedCount': ' · {count}件未マッピング',

  // ScheduleGenerateModal
  'generateModal.title': 'タイムラインを作成 / 再生成',
  'generateModal.startDateLabel': 'プロジェクト開始日',
  'generateModal.nonWorkingDayWarning': 'この日付は{day}（非作業日）です。最初の項目は自動的に次の作業日に移動されます。',
  'generateModal.scopeLabel': 'タイムラインを生成する対象',
  'generateModal.scopeAll': 'すべてのアクティブなスケジュール項目',
  'generateModal.scopeAllDesc': '{count}件の含まれる項目に日付が設定されます。',
  'generateModal.scopeUnfinished': '未完了のアクティブ項目のみ',
  'generateModal.scopeUnfinishedDesc': '{count}件の未完了項目に日付が設定されます。完了済み項目は既存の日付を保持します。',
  'generateModal.modeLabel': '再生成モード',
  'generateModal.modeFillEmpty': '空の日付のみ入力',
  'generateModal.modeFillEmptyDesc': '開始日と終了日がまだない項目にのみ日付を割り当てます。',
  'generateModal.modeOverwrite': 'すべてのスケジュール日付を上書き',
  'generateModal.modeOverwriteDesc': '含まれるすべてのスケジュール項目の既存の開始日と終了日を置き換えます。',
  'generateModal.modeOverwriteWarning': '含まれるスケジュール項目の既存の開始日と終了日が置き換えられます。進捗と完了ステータスは変更されません。',
  'generateModal.generating': '生成中...',
  'generateModal.generateBtn': 'タイムラインを生成',
  'generateModal.overwriteTitle': '既存の日付を上書きしますか？',
  'generateModal.overwriteDesc': '一部のスケジュール項目にはすでに日付が割り当てられています。含まれるすべての項目の既存の開始日と終了日が置き換えられます。',
  'generateModal.overwriteWarning': '進捗と完了ステータスは変更されません。',
  'generateModal.cancel': 'キャンセル',
  'generateModal.overwriteGenerate': '上書きして生成',

  // ScheduleBaselineModal
  'baselineModal.baselineExists': 'ベースラインが既に存在します',
  'baselineModal.setBaseline': 'ベースラインを設定',
  'baselineModal.existsDesc': 'このプロジェクトにはすでにベースラインが存在します。ベースライン日付を上書きして新しいスナップショットを作成しますか、それとも新しいスナップショットのみを作成しますか？',
  'baselineModal.noBaselineDesc': 'すべてのスケジュール項目の現在の開始日と終了日をベースラインとして保存します。これにより、後でスケジュールのずれを追跡できます。',
  'baselineModal.overwriteAndSnapshot': 'ベースラインを上書きしてスナップショットを作成',
  'baselineModal.snapshotOnly': '新しいスナップショットのみを作成',
  'baselineModal.setBaselineBtn': 'ベースラインを設定',
  'baselineModal.cancel': 'キャンセル',

  // ScheduleAlertsPanel
  'alertsPanel.alertCount': '{count}件のスケジュールアラート',
  'alertsPanel.alertCountPlural': '{count}件のスケジュールアラート',
  'alertsPanel.filterAll': 'すべて',
  'alertsPanel.filterCriticalDelayed': 'クリティカル遅延',
  'alertsPanel.filterAtRisk': 'リスク',
  'alertsPanel.filterBehind': '遅れ',
  'alertsPanel.moreHidden': '{count}件のアラートが非表示',

  // ScheduleSummaryCards
  'summaryCards.projectCompletion': 'プロジェクト完了',
  'summaryCards.baselineCompletion': 'ベースライン完了',
  'summaryCards.noBaseline': 'ベースラインなし',
  'summaryCards.scheduleVariance': 'スケジュール差異',
  'summaryCards.behindDays': '+{n}日遅れ',
  'summaryCards.aheadDays': '{n}日前倒し',
  'summaryCards.onBaseline': 'ベースライン通り',
  'summaryCards.criticalItems': 'クリティカル項目',
  'summaryCards.onCriticalPath': 'クリティカルパス上',
  'summaryCards.delayedItems': '遅延項目',
  'summaryCards.behindSchedule': 'スケジュール遅れ',
  'summaryCards.atRiskItems': 'リスク項目',
  'summaryCards.dueWithin3Days': '3日以内に期限',
  'summaryCards.scheduleStatus': 'スケジュール状況',
  'summaryCards.scheduleHealth': 'スケジュール健全性',

  // ScheduleSubcontractorView
  'subView.projectSchedule': 'プロジェクトスケジュール',
  'subView.scheduleItemsCount': '{count}件のスケジュール項目 · 読み取り専用',
  'subView.mySchedule': 'マイスケジュール',
  'subView.fullProject': 'プロジェクト全体',
  'subView.cards': 'カード',
  'subView.gantt': 'ガント',
  'subView.stageContext': 'ステージ状況',
  'subView.noAssigned': 'まだ割り当てられた項目がありません',
  'subView.noAssignedDesc': '現在、あなたの会社に割り当てられたスケジュール項目がありません。プロジェクト全体のスケジュールを表示しています。',
  'subView.readOnly': '読み取り専用ビューです。スケジュール日付の更新は管理者にお問い合わせください。',
  'subView.noScheduleYet': 'スケジュールなし',
  'subView.noScheduleYetDesc': 'プロジェクトスケジュールはまだ設定されていません。後でご確認ください。',
  'subView.noItemsToDisplay': '表示するスケジュール項目がありません。',
  'subView.delayedAttention': '遅延 / 要対応',
  'subView.thisWeek': '今週',
  'subView.nextTwoWeeks': '今後2週間',
  'subView.upcomingWork': '今後の作業',
  'subView.workingDays': '作業日',
  'subView.progress': '進捗',
  'subView.linkedStages': 'リンクされたステージ',
  'subView.notes': 'メモ',
  'subView.close': '閉じる',
  'subView.start': '開始',
  'subView.end': '終了',
  'subView.duration': '期間',
  'subView.delayed': '遅延',
  'subView.atRisk': 'リスク',
  'subView.onTrack': '順調',
  'subView.comingUp': '予定',
  'subView.dueSoon': '期限間近',
  'subView.attentionNeeded': '要対応',
  'subView.completed': '完了',

  // ScheduleExportPanel
  'exportPanel.title': 'スケジュールをエクスポート',
  'exportPanel.exportToPDF': 'PDFにエクスポート',
  'exportPanel.exportToPDFDesc': 'スケジュールリストをPDFとして印刷',
  'exportPanel.exportToCSV': 'CSVにエクスポート',
  'exportPanel.exportToCSVDesc': 'スケジュールをスプレッドシートとしてダウンロード',
  'exportPanel.print': 'スケジュールを印刷',
  'exportPanel.printDesc': 'ブラウザの印刷ダイアログを開く',
  'exportPanel.note': 'ガントチャートのPDFエクスポートは後で改善されます。現在はリストエクスポートをご利用ください。',
  'exportPanel.csvSuccess': 'CSVのエクスポートが完了しました',
  'exportPanel.csvFailed': 'CSVのエクスポートに失敗しました。再試行してください。',
  'exportPanel.pdfSuccess': 'PDFリストをエクスポートしました。ブラウザの印刷ダイアログでPDFとして保存してください。',
  'exportPanel.pdfFailed': 'PDFのエクスポートに失敗しました。再試行してください。',
  'exportPanel.popupBlocked': 'ポップアップがブロックされました。ポップアップを許可して再試行してください。',
  'exportPanel.noPrintableItems': 'エクスポートまたは印刷できる含まれたスケジュールタスクがありません。',

  // BuildertrendImportModal
  'btImport.title': 'Buildertrend スケジュールをインポート',
  'btImport.itemsFromPDF': 'PDFから{count}件の項目',
  'btImport.filterAll': 'すべて',
  'btImport.filterChanges': '変更のみ',
  'btImport.filterNew': '新規項目',
  'btImport.filterExact': '完全一致',
  'btImport.filterHigh': '高',
  'btImport.filterMedium': '中',
  'btImport.filterLow': '低',
  'btImport.filterNoMatch': '一致なし',
  'btImport.selectAll': 'すべて選択',
  'btImport.deselectAll': '選択解除',
  'btImport.selectedOf': '{selected}件選択中 · {withChanges}件に変更あり',
  'btImport.willBeImported': '{total}件中{selected}件がインポートされます',
  'btImport.noMatchFilter': 'このフィルターに一致する項目がありません。',
  'btImport.back': '戻る',
  'btImport.cancel': 'キャンセル',
  'btImport.reviewConfirm': '確認して実行',
  'btImport.saving': '保存中…',
  'btImport.confirmImport': 'インポートを確認',
  'btImport.changes': '変更',
  'btImport.matched': '一致',
  'btImport.newItem': '新規項目',
  'btImport.current': '現在',
  'btImport.new': '新しい',
  'btImport.color': '色',
  'btImport.reviewBeforeConfirm': '確認前にレビューしてください',
  'btImport.reviewDesc': '{update}件の既存スケジュール項目を更新し、{create}件の新規項目を作成します。進捗と完了ステータスは変更されません。',
  'btImport.itemsToUpdate': '更新する項目（{count}件）',
  'btImport.newItemsToCreate': '新規作成する項目（{count}件）',
  'btImport.columnNo': '#',
  'btImport.columnPDFTitle': 'PDFタイトル',
  'btImport.columnMatchedItem': '一致した項目',
  'btImport.columnOldStart': '旧開始日',
  'btImport.columnNewStart': '新開始日',
  'btImport.columnDuration': '期間',
  'btImport.columnColor': '色',
  'btImport.columnTitle': 'タイトル',
  'btImport.columnStart': '開始',
  'btImport.columnEnd': '終了',
  'btImport.columnPhase': 'フェーズ',

  // ScheduleFilterChips
  'filterChips.all': 'すべて',
  'filterChips.criticalPath': 'クリティカルパス',
  'filterChips.delayed': '遅延',
  'filterChips.atRisk': 'リスク',
  'filterChips.completed': '完了',
  'filterChips.excluded': '除外',

  // StagesTab / SubStageCard
  'stagesCard.checksCount': '{checked}/{total}件のチェック',
  'stagesCard.paymentPercent': '{n}%支払い',
  'stagesCard.progressPct': '{pct}%進捗',

  // ChecklistTab sub-stage check count
  'checklistSub.checksCount': '{completed}/{total}件のチェック',
  'checklistSub.paymentPercent': '{n}%支払い',

  // Status labels (Part 9)
  'status.open': '未対応',
  'status.overdue': '期限超過',
  'status.upcoming': '予定',
  'status.published': '公開済み',

  // Mobile-short CTA labels
  'mobile.markAllPendingComplete': '保留項目をすべて完了',
  'mobile.createDefaultChecklist': 'チェックリストを作成',
  'mobile.reviewPendingItems': '保留項目を確認',
  'mobile.generateInitialTimeline': 'タイムライン生成',
  'mobile.sendInstruction': '指示書を送信',
  'mobile.createChangeOrder': '変更指示',
  'mobile.assignSubcontractor': '下請業者を割り当て',
  'mobile.recalculateProgress': '再計算',
  'mobile.createScheduleFromTemplate': 'スケジュール作成',
  'mobile.createDefaultChecklistForProject': 'チェックリスト作成',
};



export default mgmt;